import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CheckoutPaymentsAction: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FlowContext: { input: any; output: any; }
  Instant: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Markdown: { input: any; output: any; }
  PaymentMethodDetails: { input: any; output: any; }
  PaymentMethodsResponse: { input: any; output: any; }
  PricingFormData: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Url: { input: any; output: any; }
};

/**
 * The agreement is the actual, immutable reincarnation of an insurance that is active on a certain date date.
 * It carries the actual relevant information about the insurance, such as the form/do dates, premium, insurance
 * certificates as well as the ProductVariant.
 */
export type Agreement = {
  __typename?: 'Agreement';
  /** The date this agreement took effect. */
  activeFrom: Scalars['Date']['output'];
  /** The last date this is in effect. */
  activeTo: Scalars['Date']['output'];
  /** The URL of the insurance certificate. */
  certificateUrl?: Maybe<Scalars['Url']['output']>;
  /** The reason this agreement was created, useful to distinguish between renewals and other creations for instance. */
  creationCause: AgreementCreationCause;
  /** The deductible of the agreement. */
  deductible?: Maybe<Deductible>;
  /** A localized list of key/value pairs the define the properties of this insurance. */
  displayItems: Array<AgreementDisplayItem>;
  /** Number co insured on the agreement. Null if not supported. */
  numberCoInsured?: Maybe<Scalars['Int']['output']>;
  /** The monthly premium of this agreement. */
  premium: Money;
  /**
   * The ProductVariant of the agreement, which is the umbrella container for a lot of data related to the insurance,
   * such as names, legal documents, perils etc.
   */
  productVariant: ProductVariant;
};

export enum AgreementCreationCause {
  /**
   * This agreement was created by some kind of intervening change to the insurance, such as a move, co-insured change
   * or similar.
   */
  MidtermChange = 'MIDTERM_CHANGE',
  /** This agreement was created as part of a contract creation. This means it's the first agreement of said contract. */
  NewContract = 'NEW_CONTRACT',
  /** This agreement was created as part of the automatic renewal process of insurances. Usually yearly. */
  Renewal = 'RENEWAL',
  /**
   * No creation cause is known - this is due to the agreement being older than when we started tracking
   * creation cause.
   */
  Unknown = 'UNKNOWN'
}

/** A localized container of title/value/subtitle tuples to display in a table. */
export type AgreementDisplayItem = {
  __typename?: 'AgreementDisplayItem';
  displaySubtitle?: Maybe<Scalars['String']['output']>;
  displayTitle: Scalars['String']['output'];
  displayValue: Scalars['String']['output'];
};

export enum AppPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type AvailablePaymentMethodsResponse = {
  __typename?: 'AvailablePaymentMethodsResponse';
  paymentMethodsResponse: Scalars['PaymentMethodsResponse']['output'];
};

export type BrowserInfo = {
  acceptHeader: Scalars['String']['input'];
  colorDepth: Scalars['Int']['input'];
  javaEnabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timeZoneOffset: Scalars['Int']['input'];
  userAgent: Scalars['String']['input'];
};

export type CampaignDiscount = {
  __typename?: 'CampaignDiscount';
  amount: Money;
  months: Scalars['Int']['output'];
  percentage: Scalars['Int']['output'];
  /** The type of discount, determines the relevancy of the other fields. */
  type: CampaignDiscountType;
};

export enum CampaignDiscountType {
  /** Free for a number of months. This means `CampaignDiscount.months` is non-zero. */
  FreeMonths = 'FREE_MONTHS',
  /** A percentage discount indefinitely. This means `CampaignDiscount.percentage` is non-zero. */
  IndefinitePercentage = 'INDEFINITE_PERCENTAGE',
  /** A fixed deduction of cost. This means `CampaignDiscount.amount` is non-zero. */
  MonthlyCost = 'MONTHLY_COST',
  /**
   * A percentage discount for a number of months. This means both `CampaignDiscount.months`
   * and `CampaignDiscount.percentage` are non-zero.
   */
  MonthlyPercentage = 'MONTHLY_PERCENTAGE',
  /**
   * A hack-case to support tagging the member with some kind of partner source. This isn't an actual discount,
   * but we want to display it someplace.
   */
  VisibleNoDiscount = 'VISIBLE_NO_DISCOUNT'
}

export type Cart = {
  __typename?: 'Cart';
  /** If false, campaigns cannot be added to this cart. */
  campaignsEnabled: Scalars['Boolean']['output'];
  /** The total cost values of this cart, in terms of monthly recurring payments. */
  cost: CartCost;
  /**
   * The entries is the list of `ProductOffers` that have been placed in the cart, and thus are
   * marked for being part of a potential checkout.
   */
  entries: Array<ProductOffer>;
  id: Scalars['UUID']['output'];
  /**
   * Currently redeemed campaign, if any
   *
   * It's possible that campaignsEnabled is set to false, this means campaign is read-only and cannot be removed
   */
  redeemedCampaign?: Maybe<RedeemedCampaign>;
};

export type CartCost = {
  __typename?: 'CartCost';
  /** How much price was reduced. */
  discount: Money;
  /** Original price. */
  gross: Money;
  /** Price you will pay after discount. */
  net: Money;
};

export type ChangeTierDeductibleCommitIntentInput = {
  /** The quote to activate. */
  quoteId: Scalars['ID']['input'];
};

export type ChangeTierDeductibleCommitIntentOutput = {
  __typename?: 'ChangeTierDeductibleCommitIntentOutput';
  /**  Fail case  */
  userError?: Maybe<UserError>;
};

export type ChangeTierDeductibleCreateIntentInput = {
  /** The contract to change. */
  contractId: Scalars['ID']['input'];
  /** The source for changing tier/deductible. */
  source: ChangeTierDeductibleSource;
};

/**  Only one field can be present  */
export type ChangeTierDeductibleCreateIntentOutput = {
  __typename?: 'ChangeTierDeductibleCreateIntentOutput';
  /**  Success case  */
  intent?: Maybe<ChangeTierDeductibleIntent>;
  /**  Fail case  */
  userError?: Maybe<UserError>;
};

export type ChangeTierDeductibleDisplayItem = {
  __typename?: 'ChangeTierDeductibleDisplayItem';
  displaySubtitle?: Maybe<Scalars['String']['output']>;
  displayTitle: Scalars['String']['output'];
  displayValue: Scalars['String']['output'];
};

export type ChangeTierDeductibleFromAgreement = {
  __typename?: 'ChangeTierDeductibleFromAgreement';
  /**  The deductible if any  */
  deductible?: Maybe<Deductible>;
  /**  List of display items for the quote  */
  displayItems: Array<ChangeTierDeductibleDisplayItem>;
  /**  Premium  */
  premium: Money;
  /**  The terms  */
  productVariant: ProductVariant;
  /**  The tier level  */
  tierLevel?: Maybe<Scalars['Int']['output']>;
  /**  The tier name  */
  tierName?: Maybe<Scalars['String']['output']>;
};

export type ChangeTierDeductibleIntent = {
  __typename?: 'ChangeTierDeductibleIntent';
  /**  When change is becoming active  */
  activationDate: Scalars['Date']['output'];
  /**  The agreement to change tier/deductible on  */
  agreementToChange: ChangeTierDeductibleFromAgreement;
  /**  A sorted list of quotes in tier level.  */
  quotes: Array<ChangeTierDeductibleQuote>;
};

export type ChangeTierDeductibleQuote = {
  __typename?: 'ChangeTierDeductibleQuote';
  /**  The deductible if any  */
  deductible?: Maybe<Deductible>;
  /**  List of display items for the quote  */
  displayItems: Array<ChangeTierDeductibleDisplayItem>;
  /**  The quote id to activate when committing intent */
  id: Scalars['ID']['output'];
  /**  Premium  */
  premium: Money;
  /**  The terms  */
  productVariant: ProductVariant;
  /**  The tier level, a smaller number means lower coverage. Use this to sort the tier list.  */
  tierLevel?: Maybe<Scalars['Int']['output']>;
  /**  The tier name, eg BASIC, STANDARD, MAX. Use this enum to group quotes to get the different deductibles for the tiers.  */
  tierName?: Maybe<Scalars['String']['output']>;
};

export enum ChangeTierDeductibleSource {
  SelfService = 'SELF_SERVICE',
  TerminationBetterCoverage = 'TERMINATION_BETTER_COVERAGE',
  TerminationBetterPrice = 'TERMINATION_BETTER_PRICE'
}

export type Chat = {
  __typename?: 'Chat';
  /**
   * A message containing important information to the user, usually to display in a
   * sticky fashion at the bottom of the chat.
   */
  bannerText?: Maybe<Scalars['Markdown']['output']>;
  /** If hasNext = true the the list of messages is not complete, when you want more include the cursor in next query */
  hasNext: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The list of messages. */
  messages: Array<ChatMessage>;
  /** The cursor to include if you want to fetch more messages */
  nextUntil: Scalars['Instant']['output'];
};

export type ChatMessage = {
  id: Scalars['ID']['output'];
  sender: ChatMessageSender;
  sentAt: Scalars['Instant']['output'];
};

export type ChatMessageAction = ChatMessage & {
  __typename?: 'ChatMessageAction';
  actionTitle: Scalars['String']['output'];
  actionUrl: Scalars['Url']['output'];
  id: Scalars['ID']['output'];
  sender: ChatMessageSender;
  sentAt: Scalars['Instant']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * This describes a context in which the chat was opened to ask questions.
 *
 * The system uses this a hint to the category of the question that was sent.
 */
export enum ChatMessageContext {
  HelpCenterBuilding = 'HELP_CENTER_BUILDING',
  HelpCenterCar = 'HELP_CENTER_CAR',
  HelpCenterClaims = 'HELP_CENTER_CLAIMS',
  HelpCenterContractChanges = 'HELP_CENTER_CONTRACT_CHANGES',
  HelpCenterCoverage = 'HELP_CENTER_COVERAGE',
  HelpCenterHome = 'HELP_CENTER_HOME',
  HelpCenterMyInsurance = 'HELP_CENTER_MY_INSURANCE',
  HelpCenterPayments = 'HELP_CENTER_PAYMENTS',
  HelpCenterPet = 'HELP_CENTER_PET',
  HelpCenterTerminations = 'HELP_CENTER_TERMINATIONS',
  HelpCenterTravel = 'HELP_CENTER_TRAVEL'
}

export type ChatMessageFile = ChatMessage & {
  __typename?: 'ChatMessageFile';
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  sender: ChatMessageSender;
  sentAt: Scalars['Instant']['output'];
  signedUrl: Scalars['Url']['output'];
};

export type ChatMessageFileInput = {
  context?: InputMaybe<ChatMessageContext>;
  uploadToken: Scalars['ID']['input'];
};

export type ChatMessageMutationOutput = {
  __typename?: 'ChatMessageMutationOutput';
  message?: Maybe<ChatMessage>;
  userError?: Maybe<UserError>;
};

export type ChatMessagePage = {
  __typename?: 'ChatMessagePage';
  messages: Array<ChatMessage>;
  newerToken?: Maybe<Scalars['String']['output']>;
  olderToken?: Maybe<Scalars['String']['output']>;
};

export enum ChatMessageSender {
  Hedvig = 'HEDVIG',
  Member = 'MEMBER'
}

export type ChatMessageText = ChatMessage & {
  __typename?: 'ChatMessageText';
  id: Scalars['ID']['output'];
  sender: ChatMessageSender;
  sentAt: Scalars['Instant']['output'];
  text: Scalars['String']['output'];
};

export type ChatMessageTextInput = {
  context?: InputMaybe<ChatMessageContext>;
  text: Scalars['String']['input'];
};

export type ChatSendOutcome = {
  __typename?: 'ChatSendOutcome';
  /** Localized message if the user sends something invalid */
  error?: Maybe<UserError>;
  /** The message to manually patch in the cache at the end of the messages list for immediate user feedback */
  message?: Maybe<ChatMessage>;
  /** Status message to show the member if the message was successfully sent */
  status?: Maybe<ChatStatus>;
};

export type ChatStatus = {
  __typename?: 'ChatStatus';
  message: Scalars['String']['output'];
};

export type Claim = {
  __typename?: 'Claim';
  associatedTypeOfContract?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  claimType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Return the relevant conversation for this claim.
   *
   * These conversations can be one of two kinds:
   * - either it will be a dedicated conversation for this specific claim
   * - or it will be the "legacy conversation", containing the entire old chat history
   *
   * The first one will be given for claims that are newer, created after the release of conversations.
   * The second one for all other (older) claims.
   */
  conversation: Conversation;
  /** A list of all the member-visible, uploaded files for this claim. */
  files: Array<ClaimFile>;
  id: Scalars['ID']['output'];
  incidentDate?: Maybe<Scalars['Date']['output']>;
  memberFreeText?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<ClaimOutcome>;
  payoutAmount?: Maybe<Money>;
  payouts: Array<ClaimPayoutDetails>;
  /** Terms & conditions for the claim found using claims contractId and dateOfOccurrence, otherwise null. */
  productVariant?: Maybe<ProductVariant>;
  status?: Maybe<ClaimStatus>;
  submittedAt: Scalars['DateTime']['output'];
  /**
   * Use this relative path as the target for file uploads.
   *
   * This needs to be placed on top of the base URL of the API (usually `https://gateway.hedvig.com`
   * or the staging equivalent) like so: "<baseUrl><targetFileUploadUri>".
   *
   * This target accepts multipart file uploads, and will automatically attach the uploaded files to the given claim.
   * Therefore, the same claim can be refreshed in GraphQL and it should be visible in the `Claim.files` field.
   */
  targetFileUploadUri: Scalars['String']['output'];
};

export type ClaimFile = {
  __typename?: 'ClaimFile';
  id: Scalars['ID']['output'];
  /** The mime/media type of the file. See: https://en.wikipedia.org/wiki/Media_type */
  mimeType: Scalars['String']['output'];
  /** The name of the file - usually what the person who uploaded named the file originally. */
  name: Scalars['String']['output'];
  /**
   * A URL that contains a smaller, thumbnail version, of the file. Only applicable if the file is an image.
   *
   * It is no guarantee that the thumbnail has been generated successfully, so clients should either fallback to
   * the real URL or a placeholder.
   */
  thumbnailUrl?: Maybe<Scalars['Url']['output']>;
  /**
   * The URL where the file can be read from.
   *
   * Note that these, for security reasons, are signed and somewhat short lived - which means that the the URL might
   * become invalid for fetching. This can be fixed by simply re-loading the claim.
   */
  url: Scalars['Url']['output'];
};

export type ClaimMutationOutput = {
  __typename?: 'ClaimMutationOutput';
  claim?: Maybe<Claim>;
  userError?: Maybe<UserError>;
};

export enum ClaimOutcome {
  NotCompensated = 'NOT_COMPENSATED',
  NotCovered = 'NOT_COVERED',
  Paid = 'PAID'
}

export type ClaimPayoutDetails = {
  __typename?: 'ClaimPayoutDetails';
  ageDeduction?: Maybe<Money>;
  deductible: Money;
  paidOut: Money;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  purchasePrice?: Maybe<Money>;
  valuation: Money;
};

export enum ClaimStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Reopened = 'REOPENED'
}

export type CoInsuredInput = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

/**
 * This is a type that describes a common claim scenario. This is meant as user-presentable content,
 * and does not resemble any one particular claim.
 */
export type CommonClaimDescription = {
  __typename?: 'CommonClaimDescription';
  icon: Icon;
  id: Scalars['ID']['output'];
  layout: CommonClaimLayout;
  title: Scalars['String']['output'];
};

export type CommonClaimLayout = CommonClaimLayoutEmergency | CommonClaimLayoutTitleAndBulletPoints;

export type CommonClaimLayoutBulletPoint = {
  __typename?: 'CommonClaimLayoutBulletPoint';
  description: Scalars['String']['output'];
  icon: Icon;
  title: Scalars['String']['output'];
};

export type CommonClaimLayoutEmergency = {
  __typename?: 'CommonClaimLayoutEmergency';
  color: HedvigColor;
  /** Phone Number on E.164-format */
  emergencyNumber: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CommonClaimLayoutTitleAndBulletPoints = {
  __typename?: 'CommonClaimLayoutTitleAndBulletPoints';
  bulletPoints: Array<CommonClaimLayoutBulletPoint>;
  buttonTitle: Scalars['String']['output'];
  color: HedvigColor;
  title: Scalars['String']['output'];
};

export type ConsentResponse = {
  __typename?: 'ConsentResponse';
  consentGiven: Scalars['Boolean']['output'];
};

/**
 * A contract is a container for a specific insurance, and contains a history of the versions of that insurance,
 * called Agreements.
 */
export type Contract = {
  __typename?: 'Contract';
  /**
   * Current state of co-insured including upcoming changes.
   * If current agreement doesn't support co-insured, this is null
   */
  coInsured?: Maybe<Array<ContractCoInsured>>;
  /** The currently active/relevant agreement for this contract. */
  currentAgreement: Agreement;
  /**
   * The display name of the "exposure" of this insurance - i.e. the 'object' being insured. This could be
   * the address of an apartment, or the person having accident insurance, or the dog being insured etc.
   */
  exposureDisplayName: Scalars['String']['output'];
  /** If the insurance has been switched from a different company, this contains the relevant data */
  externalInsuranceCancellation?: Maybe<ContractExternalInsuranceCancellation>;
  id: Scalars['UUID']['output'];
  /** The first date this insurance became active - i.e. the "from date" of the first agreement. */
  masterInceptionDate: Scalars['Date']['output'];
  /** User messages to show due to self change is blocked. */
  selfChangeBlockers?: Maybe<ContractSelfChangeBlockers>;
  /** Whether or not this contract can be changed through the 'ChangeTier' API. */
  supportsChangeTier: Scalars['Boolean']['output'];
  /** Whether or not this co-insured for contract can be changed through the 'MidtermChange' API. */
  supportsCoInsured: Scalars['Boolean']['output'];
  /** Whether or not this contract can be changes through the 'MoveIntent' API. */
  supportsMoving: Scalars['Boolean']['output'];
  /** Whether or not travel certificate can be created for the contract */
  supportsTravelCertificate: Scalars['Boolean']['output'];
  /** The last date this insurance will be active, if there is one. */
  terminationDate?: Maybe<Scalars['Date']['output']>;
  /** Whether or not this contract has termination status because of missed payments */
  terminationDueToMissedPayments: Scalars['Boolean']['output'];
  /**
   * A possible upcoming change of agreement. If there are multiple upcoming changes, this one will return
   * the first.
   */
  upcomingChangedAgreement?: Maybe<Agreement>;
};

export type ContractBankSigneringCancellation = {
  __typename?: 'ContractBankSigneringCancellation';
  approveByDate: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** A co-insured on contract. */
export type ContractCoInsured = {
  __typename?: 'ContractCoInsured';
  /** The date this co-insured will be added. */
  activatesOn?: Maybe<Scalars['Date']['output']>;
  /** Co-insured birthdate. */
  birthdate?: Maybe<Scalars['Date']['output']>;
  /** First name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Whether or not any of firstName, lastName, ssn or birthdate is missing and needs to be added. */
  hasMissingInfo: Scalars['Boolean']['output'];
  /** firstName + lastName + birthDate if all are present, otherwise null */
  id?: Maybe<Scalars['ID']['output']>;
  /** Last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** National identification number if any. */
  ssn?: Maybe<Scalars['String']['output']>;
  /** The date this co-insured will be removed. */
  terminatesOn?: Maybe<Scalars['Date']['output']>;
};

/** Information about ongoing or completed cancellations of insurances with different companies */
export type ContractExternalInsuranceCancellation = {
  __typename?: 'ContractExternalInsuranceCancellation';
  bankSignering?: Maybe<ContractBankSigneringCancellation>;
  externalInsurer: ExternalInsurer;
  id: Scalars['UUID']['output'];
  status: ContractExternalInsuranceCancellationStatus;
  type: ContractExternalInsuranceCancellationType;
};

export enum ContractExternalInsuranceCancellationStatus {
  /** The cancellation process is complete */
  Completed = 'COMPLETED',
  /** The cancellation process is in progress and requires no more actions from the client */
  Initiated = 'INITIATED',
  /** The contract has been created, and has the necessary information cancelling, but the cancellation process has not been initiated */
  NotInitiated = 'NOT_INITIATED'
}

export enum ContractExternalInsuranceCancellationType {
  Banksignering = 'BANKSIGNERING'
}

export type ContractSelfChangeBlocker = {
  __typename?: 'ContractSelfChangeBlocker';
  reason: Scalars['String']['output'];
};

export type ContractSelfChangeBlockers = {
  __typename?: 'ContractSelfChangeBlockers';
  /**
   * Message to show if self change of co-insured is currently blocked. This will usually be sat if
   * contract is in a renewal period or there exists future changes on the contract.
   */
  coInsured?: Maybe<ContractSelfChangeBlocker>;
};

export type Conversation = {
  __typename?: 'Conversation';
  /**
   * Return the claim for this conversation, if it has one.
   *
   * Conversations auto-created when a claim is opened will have this, others will not.
   * The `legacyConversation` will not have any associated claim.
   */
  claim?: Maybe<Claim>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  isLegacy: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  messagePage: ChatMessagePage;
  newestMessage?: Maybe<ChatMessage>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
};


export type ConversationMessagePageArgs = {
  newerToken?: InputMaybe<Scalars['String']['input']>;
  olderToken?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSendMessageInput = {
  fileUploadToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationStartInput = {
  /** The to-be `Conversation.id` of the returned Conversation. Should be a UUID v4. */
  id: Scalars['UUID']['input'];
};

export enum CountryCode {
  /** Denmark */
  Dk = 'DK',
  /** Norway */
  No = 'NO',
  /** Sweden */
  Se = 'SE'
}

export type CrossSell = {
  __typename?: 'CrossSell';
  about: Scalars['String']['output'];
  blurHash: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  productVariants: Array<ProductVariant>;
  /** A url pointing to a product page where the member can complete the purchase */
  storeUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CrossSellType;
};

export enum CrossSellType {
  Accident = 'ACCIDENT',
  Car = 'CAR',
  Home = 'HOME',
  Pet = 'PET'
}

export enum CurrencyCode {
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK'
}

export type Deductible = {
  __typename?: 'Deductible';
  /**  The fixed deductible amount if any  */
  amount: Money;
  /**  The deductible display sub title  */
  displayText: Scalars['String']['output'];
  /**  The deductible percentage if any  */
  percentage: Scalars['Int']['output'];
};

export type DirectDebitResponse2 = {
  __typename?: 'DirectDebitResponse2';
  orderId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Entrypoint = {
  __typename?: 'Entrypoint';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Array<EntrypointOption>>;
};

export type EntrypointGroup = {
  __typename?: 'EntrypointGroup';
  displayName: Scalars['String']['output'];
  entrypoints: Array<Entrypoint>;
  /** @deprecated Should not be used */
  iconUrl: Scalars['Url']['output'];
  id: Scalars['ID']['output'];
};

export type EntrypointOption = {
  __typename?: 'EntrypointOption';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EntrypointSearchInput = {
  entrypointGroupId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  type: EntrypointType;
};

export enum EntrypointType {
  Claim = 'CLAIM'
}

/** Input for `Mutation.sendEvent` */
export type EventInput = {
  /** The client timestamp. */
  clientTimestamp: Scalars['DateTime']['input'];
  /** The event data. */
  data: Scalars['JSON']['input'];
  /** The id of the event. */
  id: Scalars['ID']['input'];
  /** The session the event belongs to. */
  sessionId: Scalars['ID']['input'];
  /** The event type. */
  type: Scalars['String']['input'];
};

export type ExternalInsuranceCancellation = {
  __typename?: 'ExternalInsuranceCancellation';
  /** The latest date the insurance needs to be approved with banksignering */
  bankSigneringApproveByDate: Scalars['Date']['output'];
  /** The currently set external insurer. */
  externalInsurer?: Maybe<ExternalInsurer>;
  /** Determines if and how we can help the user with cancellation. */
  option: ExternalInsuranceCancellationOption;
  /** True if cancellation has been requested. */
  requested: Scalars['Boolean']['output'];
};

export enum ExternalInsuranceCancellationOption {
  /** We can offer BankSignering. */
  Banksignering = 'BANKSIGNERING',
  /** BankSignering is supported for the insurance but cannot be done with the given start date */
  BanksigneringInvalidRenewalDate = 'BANKSIGNERING_INVALID_RENEWAL_DATE',
  /** We can offer cancellation based on internal IEX work at Hedvig. */
  Iex = 'IEX',
  /** We cannot offer cancellation. */
  None = 'NONE'
}

export type ExternalInsurer = {
  __typename?: 'ExternalInsurer';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insurelyId?: Maybe<Scalars['String']['output']>;
};

export type FirstVetAction = {
  __typename?: 'FirstVetAction';
  sections: Array<FirstVetSection>;
};

export type FirstVetSection = {
  __typename?: 'FirstVetSection';
  buttonTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Flow = {
  __typename?: 'Flow';
  context: Scalars['FlowContext']['output'];
  currentStep: FlowStep;
  id: Scalars['ID']['output'];
  progress?: Maybe<FlowProgress>;
};

export type FlowClaimAudioContent = {
  __typename?: 'FlowClaimAudioContent';
  /**  The stored url to be used in the next step input  */
  audioUrl: Scalars['Url']['output'];
  /**  The url to get audio data from S3  */
  signedUrl: Scalars['Url']['output'];
};

export type FlowClaimAudioRecordingInput = {
  audioUrl?: InputMaybe<Scalars['Url']['input']>;
  freeText?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimAudioRecordingStep = FlowStep & {
  __typename?: 'FlowClaimAudioRecordingStep';
  audioContent?: Maybe<FlowClaimAudioContent>;
  freeText?: Maybe<Scalars['String']['output']>;
  freeTextAvailable: Scalars['Boolean']['output'];
  freeTextQuestions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  questions: Array<Scalars['String']['output']>;
};

export type FlowClaimAutomaticAutogiroPayout = FlowClaimCheckoutMethod & {
  __typename?: 'FlowClaimAutomaticAutogiroPayout';
  amount: Money;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FlowClaimAutomaticAutogiroPayoutInput = {
  amount: Scalars['Float']['input'];
};

export type FlowClaimCheckoutMethod = {
  id: Scalars['ID']['output'];
};

export type FlowClaimConfirmEmergencyInput = {
  confirmEmergency: Scalars['Boolean']['input'];
};

export type FlowClaimConfirmEmergencyOption = {
  __typename?: 'FlowClaimConfirmEmergencyOption';
  displayName: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FlowClaimConfirmEmergencyStep = FlowStep & {
  __typename?: 'FlowClaimConfirmEmergencyStep';
  confirmEmergency?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  options: Array<FlowClaimConfirmEmergencyOption>;
  text: Scalars['String']['output'];
};

export type FlowClaimContractOption = {
  __typename?: 'FlowClaimContractOption';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FlowClaimContractSelectInput = {
  contractId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FlowClaimContractSelectStep = FlowStep & {
  __typename?: 'FlowClaimContractSelectStep';
  id: Scalars['ID']['output'];
  options: Array<FlowClaimContractOption>;
};

export type FlowClaimDateOfOccurrenceInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
};

export type FlowClaimDateOfOccurrencePlusLocationInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  subLocation?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimDateOfOccurrencePlusLocationStep = FlowStep & {
  __typename?: 'FlowClaimDateOfOccurrencePlusLocationStep';
  dateOfOccurrenceStep: FlowClaimDateOfOccurrenceStep;
  id: Scalars['ID']['output'];
  locationStep: FlowClaimLocationStep;
};

export type FlowClaimDateOfOccurrenceStep = FlowStep & {
  __typename?: 'FlowClaimDateOfOccurrenceStep';
  dateOfOccurrence?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  maxDate: Scalars['Date']['output'];
};

export type FlowClaimDeflectChatStep = FlowStep & {
  __typename?: 'FlowClaimDeflectChatStep';
  id: Scalars['ID']['output'];
};

export type FlowClaimDeflectEirStep = FlowStep & {
  __typename?: 'FlowClaimDeflectEirStep';
  id: Scalars['ID']['output'];
  partners: Array<FlowClaimDeflectPartner>;
};

export type FlowClaimDeflectEmergencyStep = FlowStep & {
  __typename?: 'FlowClaimDeflectEmergencyStep';
  id: Scalars['ID']['output'];
  partners: Array<FlowClaimDeflectPartner>;
};

export type FlowClaimDeflectGlassDamageStep = FlowStep & {
  __typename?: 'FlowClaimDeflectGlassDamageStep';
  id: Scalars['ID']['output'];
  partners: Array<FlowClaimDeflectPartner>;
};

export type FlowClaimDeflectPartner = {
  __typename?: 'FlowClaimDeflectPartner';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['Url']['output']>;
};

export type FlowClaimDeflectPestsStep = FlowStep & {
  __typename?: 'FlowClaimDeflectPestsStep';
  id: Scalars['ID']['output'];
  partners: Array<FlowClaimDeflectPartner>;
};

export type FlowClaimDeflectTowingStep = FlowStep & {
  __typename?: 'FlowClaimDeflectTowingStep';
  id: Scalars['ID']['output'];
  partners: Array<FlowClaimDeflectPartner>;
};

export type FlowClaimFailedStep = FlowStep & {
  __typename?: 'FlowClaimFailedStep';
  id: Scalars['ID']['output'];
};

export type FlowClaimFileUpload = {
  __typename?: 'FlowClaimFileUpload';
  /**  The stored reference to be used in the next step input  */
  fileId: Scalars['ID']['output'];
  /**  The mime/media type of the file. See: https://en.wikipedia.org/wiki/Media_type  */
  mimeType: Scalars['String']['output'];
  /**  The file name  */
  name: Scalars['String']['output'];
  /**  The url to get file data from S3  */
  signedUrl: Scalars['Url']['output'];
};

export type FlowClaimFileUploadInput = {
  fileIds: Array<Scalars['ID']['input']>;
};

export type FlowClaimFileUploadStep = FlowStep & {
  __typename?: 'FlowClaimFileUploadStep';
  id: Scalars['ID']['output'];
  targetUploadUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uploads: Array<FlowClaimFileUpload>;
};

export type FlowClaimInfo = {
  id: Scalars['ID']['output'];
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueType>;
};

export type FlowClaimInfoDate = FlowClaimInfo & {
  __typename?: 'FlowClaimInfoDate';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Date']['output']>;
  min?: Maybe<Scalars['Date']['output']>;
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueDate>;
};

export type FlowClaimInfoInteger = FlowClaimInfo & {
  __typename?: 'FlowClaimInfoInteger';
  id: Scalars['ID']['output'];
  isSelectable: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueInteger>;
};

export type FlowClaimInfoRequiresValue = {
  __typename?: 'FlowClaimInfoRequiresValue';
  id: Scalars['ID']['output'];
  operator: Scalars['ID']['output'];
  value: ValueType;
};

export type FlowClaimInfoSelect = FlowClaimInfo & {
  __typename?: 'FlowClaimInfoSelect';
  id: Scalars['ID']['output'];
  isMulti: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  options: Array<FlowClaimInfoSelectOption>;
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueArray>;
};

export type FlowClaimInfoSelectOption = {
  __typename?: 'FlowClaimInfoSelectOption';
  displayName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FlowClaimInfoStep = FlowStep & {
  __typename?: 'FlowClaimInfoStep';
  id: Scalars['ID']['output'];
  infos: Array<Array<FlowClaimInfo>>;
};

export type FlowClaimInfoStepInput = {
  values: Array<FlowClaimInfoValueInput>;
};

export type FlowClaimInfoText = FlowClaimInfo & {
  __typename?: 'FlowClaimInfoText';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueString>;
};

export type FlowClaimInfoValueInput = {
  arrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimInfoYesNo = FlowClaimInfo & {
  __typename?: 'FlowClaimInfoYesNo';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  requires?: Maybe<Array<FlowClaimInfoRequiresValue>>;
  value?: Maybe<ValueBoolean>;
};

export type FlowClaimItemBrandInput = {
  itemBrandId: Scalars['ID']['input'];
  itemTypeId: Scalars['ID']['input'];
};

export type FlowClaimItemBrandOption = {
  __typename?: 'FlowClaimItemBrandOption';
  displayName: Scalars['String']['output'];
  itemBrandId: Scalars['ID']['output'];
  itemTypeId: Scalars['ID']['output'];
};

export type FlowClaimItemModelInput = {
  itemModelId: Scalars['UUID']['input'];
};

export type FlowClaimItemModelOption = {
  __typename?: 'FlowClaimItemModelOption';
  displayName: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  itemBrandId: Scalars['ID']['output'];
  itemModelId: Scalars['UUID']['output'];
  itemTypeId: Scalars['ID']['output'];
};

export type FlowClaimItemProblemOption = {
  __typename?: 'FlowClaimItemProblemOption';
  displayName: Scalars['String']['output'];
  itemProblemId: Scalars['ID']['output'];
};

export type FlowClaimLocationInput = {
  location?: InputMaybe<Scalars['ID']['input']>;
  subLocation?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimLocationOption = {
  __typename?: 'FlowClaimLocationOption';
  displayName: Scalars['String']['output'];
  value: Scalars['ID']['output'];
};

export type FlowClaimLocationStep = FlowStep & {
  __typename?: 'FlowClaimLocationStep';
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['ID']['output']>;
  options: Array<FlowClaimLocationOption>;
  subOptions?: Maybe<Array<FlowClaimSubLocationOption>>;
};

export type FlowClaimPersonOption = {
  __typename?: 'FlowClaimPersonOption';
  fullName?: Maybe<Scalars['String']['output']>;
  isHolder: Scalars['Boolean']['output'];
  isSelected: Scalars['Boolean']['output'];
  ssn?: Maybe<Scalars['String']['output']>;
};

export type FlowClaimPersonSelectInput = {
  selected: Array<FlowClaimPersonSelectedInput>;
};

export type FlowClaimPersonSelectStep = FlowStep & {
  __typename?: 'FlowClaimPersonSelectStep';
  id: Scalars['ID']['output'];
  options: Array<FlowClaimPersonOption>;
};

export type FlowClaimPersonSelectedInput = {
  fullName: Scalars['String']['input'];
  isHolder: Scalars['Boolean']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type FlowClaimPhoneNumberStep = FlowStep & {
  __typename?: 'FlowClaimPhoneNumberStep';
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type FlowClaimSingleItemCheckoutCompensation = {
  deductible: Money;
  id: Scalars['ID']['output'];
  payoutAmount: Money;
};

export type FlowClaimSingleItemCheckoutInput = {
  automaticAutogiro?: InputMaybe<FlowClaimAutomaticAutogiroPayoutInput>;
};

export type FlowClaimSingleItemCheckoutRepairCompensation = FlowClaimSingleItemCheckoutCompensation & {
  __typename?: 'FlowClaimSingleItemCheckoutRepairCompensation';
  deductible: Money;
  id: Scalars['ID']['output'];
  payoutAmount: Money;
  repairCost: Money;
};

export type FlowClaimSingleItemCheckoutStep = FlowStep & {
  __typename?: 'FlowClaimSingleItemCheckoutStep';
  availableCheckoutMethods: Array<FlowClaimCheckoutMethod>;
  compensation: FlowClaimSingleItemCheckoutCompensation;
  /** @deprecated Use compensation instead */
  deductible: Money;
  /** @deprecated Use compensation instead */
  depreciation: Money;
  id: Scalars['ID']['output'];
  /** @deprecated Use compensation instead */
  payoutAmount: Money;
  /** @deprecated Use compensation instead */
  price: Money;
  singleItemStep?: Maybe<FlowClaimSingleItemStep>;
};

export type FlowClaimSingleItemCheckoutValueCompensation = FlowClaimSingleItemCheckoutCompensation & {
  __typename?: 'FlowClaimSingleItemCheckoutValueCompensation';
  deductible: Money;
  depreciation: Money;
  id: Scalars['ID']['output'];
  payoutAmount: Money;
  price: Money;
};

export type FlowClaimSingleItemInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FlowClaimSingleItemStep = FlowStep & {
  __typename?: 'FlowClaimSingleItemStep';
  availableItemBrands?: Maybe<Array<FlowClaimItemBrandOption>>;
  availableItemModels?: Maybe<Array<FlowClaimItemModelOption>>;
  availableItemProblems?: Maybe<Array<FlowClaimItemProblemOption>>;
  customName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  preferredCurrency: CurrencyCode;
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchasePrice?: Maybe<Money>;
  purchasePriceApplicable: Scalars['Boolean']['output'];
  selectedItemBrand?: Maybe<Scalars['ID']['output']>;
  selectedItemModel?: Maybe<Scalars['ID']['output']>;
  selectedItemProblems: Array<Scalars['ID']['output']>;
};

export type FlowClaimStartInput = {
  entrypointId?: InputMaybe<Scalars['ID']['input']>;
  entrypointOptionId?: InputMaybe<Scalars['ID']['input']>;
  supportedSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FlowClaimSubLocationOption = {
  __typename?: 'FlowClaimSubLocationOption';
  displayName: Scalars['String']['output'];
  parentId: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type FlowClaimSuccessStep = FlowStep & {
  __typename?: 'FlowClaimSuccessStep';
  id: Scalars['ID']['output'];
};

export type FlowClaimSummaryInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FlowClaimSummaryStep = FlowStep & {
  __typename?: 'FlowClaimSummaryStep';
  audioRecordingStep?: Maybe<FlowClaimAudioRecordingStep>;
  dateOfOccurrenceStep: FlowClaimDateOfOccurrenceStep;
  fileUploadStep?: Maybe<FlowClaimFileUploadStep>;
  id: Scalars['ID']['output'];
  locationStep: FlowClaimLocationStep;
  singleItemStep?: Maybe<FlowClaimSingleItemStep>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type FlowProgress = {
  __typename?: 'FlowProgress';
  clearedSteps: Scalars['Int']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type FlowStep = {
  id: Scalars['ID']['output'];
};

export type FlowTerminationDateInput = {
  terminationDate: Scalars['Date']['input'];
};

export type FlowTerminationDateStep = FlowStep & {
  __typename?: 'FlowTerminationDateStep';
  id: Scalars['ID']['output'];
  maxDate: Scalars['Date']['output'];
  minDate: Scalars['Date']['output'];
};

export type FlowTerminationDeletionInput = {
  /** This has no significance and is ignored by the backend. It exists to satisfy some codegen limitations */
  confirmed: Scalars['Boolean']['input'];
};

export type FlowTerminationDeletionStep = FlowStep & {
  __typename?: 'FlowTerminationDeletionStep';
  /** @deprecated Unnecessary field */
  disclaimer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FlowTerminationFailedStep = FlowStep & {
  __typename?: 'FlowTerminationFailedStep';
  id: Scalars['ID']['output'];
};

export type FlowTerminationStartInput = {
  contractId: Scalars['ID']['input'];
};

export type FlowTerminationSuccessStep = FlowStep & {
  __typename?: 'FlowTerminationSuccessStep';
  id: Scalars['ID']['output'];
  terminationDate?: Maybe<Scalars['Date']['output']>;
};

export type FlowTerminationSurveyDataInput = {
  optionId: Scalars['ID']['input'];
  /** User submitted text feedback, if any */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FlowTerminationSurveyInput = {
  data: FlowTerminationSurveyDataInput;
};

export type FlowTerminationSurveyOption = {
  __typename?: 'FlowTerminationSurveyOption';
  feedBack?: Maybe<FlowTerminationSurveyOptionFeedback>;
  id: Scalars['ID']['output'];
  subOptions?: Maybe<Array<FlowTerminationSurveyOption>>;
  suggestion?: Maybe<FlowTerminationSurveyOptionSuggestion>;
  title: Scalars['String']['output'];
};

export type FlowTerminationSurveyOptionFeedback = {
  __typename?: 'FlowTerminationSurveyOptionFeedback';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
};

export type FlowTerminationSurveyOptionSuggestion = {
  id: Scalars['ID']['output'];
};

export type FlowTerminationSurveyOptionSuggestionAction = FlowTerminationSurveyOptionSuggestion & {
  __typename?: 'FlowTerminationSurveyOptionSuggestionAction';
  action: FlowTerminationSurveyRedirectAction;
  buttonTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FlowTerminationSurveyOptionSuggestionRedirect = FlowTerminationSurveyOptionSuggestion & {
  __typename?: 'FlowTerminationSurveyOptionSuggestionRedirect';
  buttonTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export enum FlowTerminationSurveyRedirectAction {
  ChangeTierFoundBetterPrice = 'CHANGE_TIER_FOUND_BETTER_PRICE',
  ChangeTierMissingCoverageAndTerms = 'CHANGE_TIER_MISSING_COVERAGE_AND_TERMS',
  UpdateAddress = 'UPDATE_ADDRESS'
}

export type FlowTerminationSurveyStep = FlowStep & {
  __typename?: 'FlowTerminationSurveyStep';
  id: Scalars['ID']['output'];
  options: Array<FlowTerminationSurveyOption>;
};

export enum HedvigColor {
  Black = 'Black',
  BlackPurple = 'BlackPurple',
  DarkGray = 'DarkGray',
  DarkPurple = 'DarkPurple',
  LightGray = 'LightGray',
  OffBlack = 'OffBlack',
  OffWhite = 'OffWhite',
  Pink = 'Pink',
  Purple = 'Purple',
  Turquoise = 'Turquoise',
  White = 'White',
  Yellow = 'Yellow'
}

export type Icon = {
  __typename?: 'Icon';
  variants: IconVariants;
};

export type IconVariant = {
  __typename?: 'IconVariant';
  pdfUrl: Scalars['String']['output'];
  svgUrl: Scalars['String']['output'];
};

export type IconVariants = {
  __typename?: 'IconVariants';
  dark: IconVariant;
  light: IconVariant;
};

export type InsurableLimit = {
  __typename?: 'InsurableLimit';
  description: Scalars['String']['output'];
  label: Scalars['String']['output'];
  limit: Scalars['String']['output'];
  type: InsurableLimitType;
};

export enum InsurableLimitType {
  Bike = 'BIKE',
  Deductible = 'DEDUCTIBLE',
  DeductibleAllRisk = 'DEDUCTIBLE_ALL_RISK',
  DeductibleNatureDamage = 'DEDUCTIBLE_NATURE_DAMAGE',
  DentalTreatment = 'DENTAL_TREATMENT',
  GoodsFamily = 'GOODS_FAMILY',
  GoodsIndividual = 'GOODS_INDIVIDUAL',
  InsuredAmount = 'INSURED_AMOUNT',
  LostLuggage = 'LOST_LUGGAGE',
  MedicalExpenses = 'MEDICAL_EXPENSES',
  PermanentInjury = 'PERMANENT_INJURY',
  TravelCancellation = 'TRAVEL_CANCELLATION',
  TravelDays = 'TRAVEL_DAYS',
  TravelDelayedLuggage = 'TRAVEL_DELAYED_LUGGAGE',
  TravelDelayedOnTrip = 'TRAVEL_DELAYED_ON_TRIP',
  TravelIllnessInjuryTransportationHome = 'TRAVEL_ILLNESS_INJURY_TRANSPORTATION_HOME',
  Treatment = 'TREATMENT'
}

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  displayName: Scalars['String']['output'];
  type: InsuranceDocumentType;
  url: Scalars['String']['output'];
};

export enum InsuranceDocumentType {
  GeneralTerms = 'GENERAL_TERMS',
  PreSaleInfo = 'PRE_SALE_INFO',
  PreSaleInfoEuStandard = 'PRE_SALE_INFO_EU_STANDARD',
  PrivacyPolicy = 'PRIVACY_POLICY',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type InsurelyInitiateIframeDataCollectionInput = {
  collectionId: Scalars['String']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
};

export type InsurelyInitiateIframeDataCollectionOutput = {
  __typename?: 'InsurelyInitiateIframeDataCollectionOutput';
  dataCollectionId: Scalars['ID']['output'];
};

export type LinkInfo = {
  __typename?: 'LinkInfo';
  buttonText: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export type Location = {
  __typename?: 'Location';
  street?: Maybe<Scalars['String']['output']>;
};

/**
 * A 'Member' is the central user-like concept of our platform, referring to someone who has bought insurance
 * with Hedvig and is now as we call is a "member".
 *
 * The Member type in our schema must always refer to the member based on the current authentication, i.e. the
 * subject in the bearer token of the Authorization header.
 *
 * This type must never be used in an unauthenticated context, and it must always refer to the member in the
 * authorization header. This is usually done either by:
 * - Returning it from `Query.currentMember`
 * - or from a mutation with return type `MemberMutationOutput`, which will refer to the authenticated member.
 *
 * This is federated across multiple subgraphs, which enables us to attach data to it that "belongs to the
 * currently authenticated member", such as your "active contracts" etc. These could have just as easily been placed
 * at the top level like `Query.activeContracts`, respecting the current authentication, but placing them under
 * `Member` gives a more intuitive model when interacting with it from the outside perspective.
 */
export type Member = {
  __typename?: 'Member';
  /**
   * Fetch all the active contracts for this member. Active contracts include all insurances that are either
   * active today, or to-be-active in the future.
   */
  activeContracts: Array<Contract>;
  claims: Array<Claim>;
  conversations: Array<Conversation>;
  countryCode: CountryCode;
  crossSells: Array<CrossSell>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** Upcoming charge info, null in case of pending or fully settled members */
  futureCharge?: Maybe<MemberCharge>;
  /** @deprecated Use `paymentInformation.status` instead */
  hasActivePaymentConnection: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Carries messages to be shown to a logged in member, such as possible delays
   * in service or outage announcements.
   */
  importantMessages: Array<MemberImportantMessage>;
  /**
   * A breakdown of the total cost of this member's insurance.
   *
   * The exact charge every month can vary based on other factors,
   */
  insuranceCost: MemberInsuranceCost;
  /** Whether this member is entitled to make a claim, based on their historical contracts. */
  isEligibleToMakeClaim: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  legacyConversation?: Maybe<Conversation>;
  memberActions?: Maybe<MemberActions>;
  partnerData?: Maybe<PartnerData>;
  /** List of all past charges, this list will be empty in case of pending members */
  pastCharges: Array<MemberCharge>;
  /** Payment information for this member. */
  paymentInformation: MemberPaymentInformation;
  /** Fetch all the pending contracts for this member. */
  pendingContracts: Array<PendingContract>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The currently redeemed campaign of this member, if any. */
  redeemedCampaigns: Array<RedeemedCampaign>;
  /** Member-specific data related to Referrals (Hedvig Forever) */
  referralInformation: MemberReferralInformation;
  ssn?: Maybe<Scalars['String']['output']>;
  /** Terminated contracts are all past contracts that have ended. */
  terminatedContracts: Array<Contract>;
  travelCertificateSpecifications: TravelCertificateSpecification;
  travelCertificates: Array<TravelCertificate>;
};

export type MemberActions = {
  __typename?: 'MemberActions';
  firstVetAction?: Maybe<FirstVetAction>;
  isCancelInsuranceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isChangeTierEnabled?: Maybe<Scalars['Boolean']['output']>;
  isConnectPaymentEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEditCoInsuredEnabled?: Maybe<Scalars['Boolean']['output']>;
  isMovingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate whether the travel certificate option should be displayed. */
  isTravelCertificateEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberId: Scalars['ID']['output'];
  sickAbroadAction?: Maybe<SickAbroadAction>;
};

/** Upcoming charge info, null in case of pending or fully settled members */
export type MemberCharge = {
  __typename?: 'MemberCharge';
  /**  usedCredit is the amount that the member has used towards their paid subscription.  */
  carriedAdjustment?: Maybe<Money>;
  /** Breakdown of the upcoming charge by contract */
  contractsChargeBreakdown: Array<MemberChargeContractBreakdownItem>;
  /** Due date of the upcoming charge */
  date: Scalars['Date']['output'];
  /** Total discount amount of the upcoming charge, includes all active discounts */
  discount: Money;
  /** Breakdown of the upcoming charge's discounts */
  discountBreakdown: Array<MemberChargeDiscountBreakdownItem>;
  /** Total gross amount of the upcoming charge based on all contracts premium divided by the number of days in the month */
  gross: Money;
  id?: Maybe<Scalars['ID']['output']>;
  /** Total net amount of the upcoming charge, (gross - discount) */
  net: Money;
  /** Past charges that have failed */
  pastFailedChargeIds: Array<Scalars['ID']['output']>;
  /**  gainedCredit is the amount that the member is owed due to settlement adjustment.  */
  settlementAdjustment?: Maybe<Money>;
  status: MemberChargeStatus;
};

export type MemberChargeContractBreakdownItem = {
  __typename?: 'MemberChargeContractBreakdownItem';
  contract: Contract;
  gross: Money;
  periods: Array<MemberChargeContractBreakdownItemPeriod>;
};

export type MemberChargeContractBreakdownItemPeriod = {
  __typename?: 'MemberChargeContractBreakdownItemPeriod';
  amount: Money;
  fromDate: Scalars['Date']['output'];
  isPreviouslyFailedCharge: Scalars['Boolean']['output'];
  toDate: Scalars['Date']['output'];
};

export type MemberChargeDiscountBreakdownItem = {
  __typename?: 'MemberChargeDiscountBreakdownItem';
  code?: Maybe<Scalars['String']['output']>;
  discount: Money;
  isReferral: Scalars['Boolean']['output'];
};

/** The status of the charge */
export enum MemberChargeStatus {
  /** The charge failed */
  Failed = 'FAILED',
  /** The charge is pending that means either has been send to payment-service or to the payment provider */
  Pending = 'PENDING',
  /** The charge was settled successfully */
  Success = 'SUCCESS',
  /** A charge that is upcoming */
  Upcoming = 'UPCOMING'
}

/** Input for `Mutation.memberDeviceRegister` */
export type MemberDeviceRegisterInput = {
  /** The platform this token is connected to. */
  platform: AppPlatform;
  /** The token to register. */
  token: Scalars['String']['input'];
};

export type MemberImportantMessage = {
  __typename?: 'MemberImportantMessage';
  id: Scalars['ID']['output'];
  /** @deprecated Use linkInfo instead, which allows for a message to not have a link at all attached and allows editing the button text too */
  link: Scalars['Url']['output'];
  linkInfo?: Maybe<LinkInfo>;
  message: Scalars['String']['output'];
};

export type MemberInsuranceCost = {
  __typename?: 'MemberInsuranceCost';
  /**
   * Comment copy-pasted from codebase:
   *
   * NOTE: this name is misleading, because it's used both for free months and for time limited discounts
   */
  freeUntil?: Maybe<Scalars['Date']['output']>;
  /** The total discount when everything is applied. */
  monthlyDiscount: Money;
  /** Total cost of the insurances before any discounts. */
  monthlyGross: Money;
  /** The total to actually be charged every month. */
  monthlyNet: Money;
};

/** Container for mutations that refer to the currently authenticated member. */
export type MemberMutationOutput = {
  __typename?: 'MemberMutationOutput';
  member?: Maybe<Member>;
  userError?: Maybe<UserError>;
};

export type MemberPaymentConnection = {
  __typename?: 'MemberPaymentConnection';
  /** A more specific description of your actual connection, such as a bank account reference. */
  descriptor: Scalars['String']['output'];
  /** An abstract display name of the connection - usually like the name of the bank you are connected to. */
  displayName: Scalars['String']['output'];
};

export enum MemberPaymentConnectionStatus {
  /** The payment connection is good to go. */
  Active = 'ACTIVE',
  /** There is no payment connection. */
  NeedsSetup = 'NEEDS_SETUP',
  /** The payment connection has been partially set up but is awaiting activation. */
  Pending = 'PENDING'
}

export type MemberPaymentInformation = {
  __typename?: 'MemberPaymentInformation';
  /** A payment connection if registered. */
  connection?: Maybe<MemberPaymentConnection>;
  /** Status of the payment connection. If ACTIVE, a `connection` should be present. */
  status: MemberPaymentConnectionStatus;
};

export type MemberReferral = {
  __typename?: 'MemberReferral';
  /** The currently active discount of this referral. */
  activeDiscount?: Maybe<Money>;
  /** The name of this referral. This reflects the name of the member created through the referral. */
  name: Scalars['String']['output'];
  /** Status of the referral - only ACTIVE referrals generate a discount. */
  status: MemberReferralStatus;
};

export type MemberReferralInformation = {
  __typename?: 'MemberReferralInformation';
  /**
   * The unique invite-code this member that can be sent to other people.
   *
   * Can be updated with `Mutation.memberReferralInformationCodeUpdate`
   */
  code: Scalars['String']['output'];
  /**
   * A value indicating the total amount of discounts this member has excluding the discounts generated
   * by referring other people.
   */
  monthlyDiscountExcludingReferrals: Money;
  /** How much a single successful referral is worth. */
  monthlyDiscountPerReferral: Money;
  /** All the referrals this connected to this member and their current status. */
  referrals: Array<MemberReferral>;
  /** The referral that ended up with this member signing. This is also overlapped with an entry in redeemedCampaign. */
  referredBy?: Maybe<MemberReferral>;
};

export type MemberReferralInformationMutationOutput = {
  __typename?: 'MemberReferralInformationMutationOutput';
  referralInformation?: Maybe<MemberReferralInformation>;
  userError?: Maybe<UserError>;
};

export enum MemberReferralStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Terminated = 'TERMINATED'
}

export type MemberUpdateEmailInput = {
  email: Scalars['String']['input'];
};

export type MemberUpdateEurobonusNumberInput = {
  eurobonusNumber: Scalars['String']['input'];
};

export type MemberUpdateLanguageInput = {
  ietfLanguageTag: Scalars['String']['input'];
};

export type MemberUpdatePhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type MidtermChangeIntent = {
  __typename?: 'MidtermChangeIntent';
  activationDate: Scalars['Date']['output'];
  currentPremium: Money;
  id: Scalars['ID']['output'];
  newPremium: Money;
  state: MidtermChangeIntentState;
};

export type MidtermChangeIntentCreateInput = {
  /**
   * The list of all co-insured to set on the agreement, i.e. size equals nbrOfCoInsured.
   * This list contains "null" entries for co-insured not yet defined.
   */
  coInsuredInputs?: InputMaybe<Array<CoInsuredInput>>;
};

export type MidtermChangeIntentMutationOutput = {
  __typename?: 'MidtermChangeIntentMutationOutput';
  intent?: Maybe<MidtermChangeIntent>;
  userError?: Maybe<UserError>;
};

export enum MidtermChangeIntentState {
  Completed = 'COMPLETED',
  Initiated = 'INITIATED'
}

/** A monetary value with currency. */
export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float']['output'];
  /** Currency of the money (ISO 4217). */
  currencyCode: CurrencyCode;
};

export type MoveAddress = {
  __typename?: 'MoveAddress';
  /**  Address city  */
  city?: Maybe<Scalars['String']['output']>;
  /**  Address id, will correlate to the contract id  */
  id: Scalars['ID']['output'];
  /**  Address postal code  */
  postalCode: Scalars['String']['output'];
  /**  Address street  */
  street: Scalars['String']['output'];
};

export enum MoveApartmentSubType {
  Own = 'OWN',
  Rent = 'RENT'
}

export enum MoveApiVersion {
  V1 = 'V1',
  V2TiersAndDeductibles = 'V2_TIERS_AND_DEDUCTIBLES'
}

export type MoveExtraBuildingInput = {
  /**  Area of extra building  */
  area: Scalars['Int']['input'];
  /**  If extra building has water connected  */
  hasWaterConnected: Scalars['Boolean']['input'];
  /**  Extra building type  */
  type: MoveExtraBuildingType;
};

export enum MoveExtraBuildingType {
  Attefall = 'ATTEFALL',
  Barn = 'BARN',
  Boathouse = 'BOATHOUSE',
  Carport = 'CARPORT',
  Friggebod = 'FRIGGEBOD',
  Garage = 'GARAGE',
  Gazebo = 'GAZEBO',
  Greenhouse = 'GREENHOUSE',
  Guesthouse = 'GUESTHOUSE',
  Other = 'OTHER',
  Outhouse = 'OUTHOUSE',
  Sauna = 'SAUNA',
  Shed = 'SHED',
  Storehouse = 'STOREHOUSE'
}

export type MoveHomeQuote = {
  __typename?: 'MoveHomeQuote';
  /**  The deductible if any  */
  deductible?: Maybe<Deductible>;
  /**  Flag to indicate if this is the default choice. Only one quote can be default  */
  defaultChoice: Scalars['Boolean']['output'];
  /**  List of display items for the quote  */
  displayItems: Array<MoveQuoteDisplayItem>;
  /**  The insurance exposure name, eg reg nbr for car, name and birthdate for cat/dog, street for home etc...  */
  exposureName: Scalars['String']['output'];
  /**  The quote id, used to commit the selected quote  */
  id: Scalars['ID']['output'];
  /**  Premium  */
  premium: Money;
  /**  The terms  */
  productVariant: ProductVariant;
  /**  When new insurance (or existing insurance address change) is becoming active  */
  startDate: Scalars['Date']['output'];
  /**  The tier level, a smaller number means lower coverage  */
  tierLevel: Scalars['Int']['output'];
  /**  The tier name, eg BASIC, STANDARD, MAX  */
  tierName: Scalars['String']['output'];
};

export type MoveIntent = {
  __typename?: 'MoveIntent';
  /**  List of members current addresses possible to move from  */
  currentHomeAddresses: Array<MoveAddress>;
  /**  All available external building types accepted for new address  */
  extraBuildingTypes: Array<MoveExtraBuildingType>;
  /**
   * Will only be present after moveIntentRequest and for new V2_TIERS_AND_DEDUCTIBLES API.
   * Quote variants for new home contract that member needs to pick one from.
   */
  homeQuotes?: Maybe<Array<MoveHomeQuote>>;
  id: Scalars['ID']['output'];
  /**  If member is eligable for apartment student insurance  */
  isApartmentAvailableforStudent?: Maybe<Scalars['Boolean']['output']>;
  /**  Max number of co-insured for an apartment to move to */
  maxApartmentNumberCoInsured?: Maybe<Scalars['Int']['output']>;
  /**  Max area of an apartment to move to  */
  maxApartmentSquareMeters?: Maybe<Scalars['Int']['output']>;
  /**  Max number of co-insured for a house to move to */
  maxHouseNumberCoInsured?: Maybe<Scalars['Int']['output']>;
  /**  Max area of a house to move to */
  maxHouseSquareMeters?: Maybe<Scalars['Int']['output']>;
  /**  The latest possible move date according to current contracts  */
  maxMovingDate: Scalars['Date']['output'];
  /**  The earliest possible move date according to current contracts  */
  minMovingDate: Scalars['Date']['output'];
  /**
   * Will only be present after moveIntentRequest and for new V2_TIERS_AND_DEDUCTIBLES API.
   * The MTA quotes for member's non-home contracts with new address.
   */
  mtaQuotes?: Maybe<Array<MoveMtaQuote>>;
  /**
   * Will only be present after moveIntentRequest and for API V1.
   * DEPRECATED!
   * The quotes to accept for moving to new address, includes one quote for the new home contract and zero
   * or more MTA quotes for other non-home contracts with new address.
   */
  quotes: Array<MoveQuote>;
  /**  Number of co-insured from existing contract to use as default  */
  suggestedNumberCoInsured: Scalars['Int']['output'];
};

/**  Only one field can be present  */
export type MoveIntentMutationOutput = {
  __typename?: 'MoveIntentMutationOutput';
  /**  Success case  */
  moveIntent?: Maybe<MoveIntent>;
  /**  Fail case  */
  userError?: Maybe<UserError>;
};

export type MoveIntentRequestInput = {
  /**  Data if to move to an apartment  */
  apartment?: InputMaybe<MoveToApartmentInput>;
  /**  The version of this API used by the client  */
  apiVersion?: InputMaybe<MoveApiVersion>;
  /**  Data if to move to house  */
  house?: InputMaybe<MoveToHouseInput>;
  /**  This is the ID you get in MoveIntent:currentHomeAddresses member selected to move from  */
  moveFromAddressId: Scalars['ID']['input'];
  /**  The new address to move to  */
  moveToAddress: MoveToAddressInput;
  /**  The moving date new insurance should be activated  */
  movingDate: Scalars['Date']['input'];
  /**  The number of co-insured on new address  */
  numberCoInsured: Scalars['Int']['input'];
  /**  The number of square meters of new home  */
  squareMeters: Scalars['Int']['input'];
};

export type MoveMtaQuote = {
  __typename?: 'MoveMtaQuote';
  /**  List of display items for the quote  */
  displayItems: Array<MoveQuoteDisplayItem>;
  /**  The insurance exposure name, eg reg nbr for car, name and birthdate for cat/dog, street for home etc...  */
  exposureName: Scalars['String']['output'];
  /**  Premium  */
  premium: Money;
  /**  The terms  */
  productVariant: ProductVariant;
  /**  When new insurance (or existing insurance address change) is becoming active  */
  startDate: Scalars['Date']['output'];
};

/**  DEPRECATED. Quotes used for the old V1 API  */
export type MoveQuote = {
  __typename?: 'MoveQuote';
  /**  List of display items for the quote  */
  displayItems: Array<MoveQuoteDisplayItem>;
  /**  The insurance exposure name, eg reg nbr for car, name and birthdate for cat/dog, street for home etc...  */
  exposureName?: Maybe<Scalars['String']['output']>;
  /**  Premium  */
  premium: Money;
  /**  The terms  */
  productVariant: ProductVariant;
  /**  When new insurance (or existing insurance address change) is becoming active  */
  startDate: Scalars['Date']['output'];
};

export type MoveQuoteDisplayItem = {
  __typename?: 'MoveQuoteDisplayItem';
  displaySubtitle?: Maybe<Scalars['String']['output']>;
  displayTitle: Scalars['String']['output'];
  displayValue: Scalars['String']['output'];
};

export type MoveToAddressInput = {
  /**  The city to move to  */
  city?: InputMaybe<Scalars['String']['input']>;
  /**  The postal code to move to  */
  postalCode: Scalars['String']['input'];
  /**  The street to move to  */
  street: Scalars['String']['input'];
};

export type MoveToApartmentInput = {
  /**  If member is student  */
  isStudent: Scalars['Boolean']['input'];
  /**  The subtype of new apartment  */
  subType: MoveApartmentSubType;
};

export type MoveToHouseInput = {
  /**  The ancillary area of new house  */
  ancillaryArea: Scalars['Int']['input'];
  /**  Extra buildings for new house  */
  extraBuildings: Array<MoveExtraBuildingInput>;
  /**  If new house is subleted  */
  isSubleted: Scalars['Boolean']['input'];
  /**  Number of bathrooms in new house  */
  numberOfBathrooms: Scalars['Int']['input'];
  /**  The year of construction of new house  */
  yearOfConstruction: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  Accept quote  */
  changeTierDeductibleCommitIntent: ChangeTierDeductibleCommitIntentOutput;
  /**  Create change tier/deductible intent  */
  changeTierDeductibleCreateIntent: ChangeTierDeductibleCreateIntentOutput;
  chatSendFile: ChatSendOutcome;
  chatSendText: ChatSendOutcome;
  contractBankSigneringCancellationInitiate: Contract;
  conversationSendMessage: ChatMessageMutationOutput;
  /**
   * Start a conversation. This is effectively creating one, but with two slight differences from a regular
   * "create something"-mutation:
   * - It lets the clients inject the ID of the conversation, which is useful for the implementation for some clients
   * - It is idempotent, so starting it again will simply return the old one unchanged
   */
  conversationStart: Conversation;
  flowClaimAudioRecordingNext: Flow;
  flowClaimConfirmEmergencyNext: Flow;
  flowClaimContractSelectNext: Flow;
  flowClaimDateOfOccurrenceNext: Flow;
  flowClaimDateOfOccurrencePlusLocationNext: Flow;
  flowClaimFileUploadNext: Flow;
  flowClaimLocationNext: Flow;
  flowClaimPersonSelectNext: Flow;
  flowClaimPhoneNumberNext: Flow;
  flowClaimSingleItemCheckoutNext: Flow;
  flowClaimSingleItemNext: Flow;
  flowClaimStart: Flow;
  flowClaimSummaryNext: Flow;
  flowTerminationDateNext: Flow;
  flowTerminationDeletionNext: Flow;
  flowTerminationStart: Flow;
  flowTerminationSurveyNext: Flow;
  /**
   * This is a re-implementation of the existing Mutation.externalInsurnaceProvider.initiateIframeDataCollection
   * mutation, as the old one uses an unsupported resolver design (nested/namespaced mutations).
   */
  insurelyInitiateIframeDataCollection: InsurelyInitiateIframeDataCollectionOutput;
  /** Redeem a campaign for the current member with the input `code`. */
  memberCampaignsRedeem: MemberMutationOutput;
  /** Remove a campaign for the current member with the given `RedeemedCampaign.id`. */
  memberCampaignsUnredeem: MemberMutationOutput;
  memberDeletionRequest?: Maybe<UserError>;
  /** Register a push-notification token to customer.io (which calls it a "Device"). */
  memberDeviceRegister: Scalars['Boolean']['output'];
  /**
   * Update the personal invite code for the current member.
   *
   * This can be personalised to take the original, rather random code like 'OWID23KS' and turn it into
   * something more appealing like 'COWABUNGA'.
   */
  memberReferralInformationCodeUpdate: MemberReferralInformationMutationOutput;
  memberUpdateEmail: MemberMutationOutput;
  memberUpdateEurobonusNumber: MemberMutationOutput;
  memberUpdateLanguage: MemberMutationOutput;
  memberUpdatePhoneNumber: MemberMutationOutput;
  memberUpdateSubscriptionPreference?: Maybe<UserError>;
  /** Commits the midterm change and creates a new agreement for it, takes id of the intent */
  midtermChangeIntentCommit: MidtermChangeIntentMutationOutput;
  /**
   * Called to change the co-insured for a contract, returns a generic output containing an intent for the change.
   * The id of the intent is used in the midtermChangeIntentCommit mutation to realize the new co-insured.
   */
  midtermChangeIntentCreate: MidtermChangeIntentMutationOutput;
  /**  Accept move, for V2_TIERS_AND_DEDUCTIBLES API the homeQuoteId is required  */
  moveIntentCommit: MoveIntentMutationOutput;
  /**  Initiate a Move intent  */
  moveIntentCreate: MoveIntentMutationOutput;
  /**  Request move  */
  moveIntentRequest: MoveIntentMutationOutput;
  /** @deprecated To be removed with old widget app */
  partnerWidgetInit: ShopSession;
  /**
   * Confirm this PriceIntent, which will use the current data (and likely `ShopSession.customer`) to generate
   * `ProductOffers` that can be added to the cart.
   */
  priceIntentConfirm: PriceIntentMutationOutput;
  /**
   * Create a `PriceIntent`.
   *
   * The `input.productName` has to be the name of a product among the ones listed at `Query.availableProducts`. The
   * choice of product also affects which data will be needed for the intent to be confirmed and to produce offers.
   */
  priceIntentCreate: PriceIntent;
  /**
   * Update the raw insurance-related data for this `PriceIntent`. This data is mostly related to the insured object
   * itself, and not the "holder" of the insurance.
   */
  priceIntentDataUpdate: PriceIntentMutationOutput;
  /**
   * Set the external insurer ID (value of `ExternalInsurer.id`) for this price intent.
   *
   * Mostly used for helping the user with cancellation/switching.
   */
  priceIntentExternalInsurerUpdate: PriceIntentMutationOutput;
  /** Associate a specific Insurely `dataCollectionId` from lookup-service with this PriceIntent. */
  priceIntentInsurelyUpdate: PriceIntentMutationOutput;
  /**
   * Update the 'cancellation requested' value of the given offers. True means that the user wants us
   * to help them with switching/cancellation, and false means that they don't.
   */
  productOffersCancellationRequestedUpdate: ProductOffersMutationOutput;
  /**
   * Change the start date of the given `ProductOffer`s by their ID.
   *
   * This is used because it's common to want to change the start date AFTER getting the offer.
   */
  productOffersStartDateUpdate: ProductOffersMutationOutput;
  registerDirectDebit2: DirectDebitResponse2;
  /** Send a batch of events to the EventTrackingService */
  sendEventBatch: Array<Scalars['ID']['output']>;
  /** Try to attach a campaign with the given code to the cart. Returns a `userError` value if the code is invalid. */
  shopSessionCartCampaignRedeem: ShopSessionMutationOutput;
  /** Remove the given campaign from the cart. */
  shopSessionCartCampaignUnredeem: ShopSessionMutationOutput;
  /** Add a list of `ProductOffer`s by their ID to the cart. */
  shopSessionCartEntriesAdd: ShopSessionMutationOutput;
  /** Remove a list of `ProductOffer`s by their ID from the cart. */
  shopSessionCartEntriesRemove: ShopSessionMutationOutput;
  /**
   * Create a `ShopSession`. The `input.countryCode` value will have implications on the behaviour of the session
   * in terms of what products can be bought using it and underlying integrations.
   */
  shopSessionCreate: ShopSession;
  /** Create partner-specific `ShopSession`.  Validates partnerName and may provide partner-specific behaviour. */
  shopSessionCreatePartner: ShopSession;
  /**
   * Update the customer of the shop session. Only non-null fields will be changed.
   * Can trigger automatic lookup of other information.
   *
   * The session can be placed in a "point of no return" state where it is no longer legal to update the customer,
   * which will generate errors.
   */
  shopSessionCustomerUpdate: ShopSessionMutationOutput;
  /**
   * Begin signing the session, with the ultimate goal of creating insurances in our system, and possibly
   * also creating a new Member.
   *
   * Signing is an asynchronous process, where the client must poll using `Query.shopSessionSigning` and follow
   * the state changes. Some signing requires external work for the user, such as Swedish BankID signing.
   */
  shopSessionStartSign: ShopSessionSigningMutationOutput;
  /** Handle payment redirection, required for 3D Secure verification on cards */
  submitAdyenRedirection2: SubmitAdyenRedirectionResponse;
  /**
   * Send in the expiry date of current insurance from switcher company, so that we can activate our
   * insurance the day after.
   */
  switcherCaseComplete: SwitcherCaseMutationOutput;
  /** Tokenize payment details per member in order to be used in future and returns the status */
  tokenizePaymentDetails2?: Maybe<TokenizationResponse>;
  travelCertificateCreate: TravelCertificate;
  updateConsent?: Maybe<ConsentResponse>;
};


export type MutationChangeTierDeductibleCommitIntentArgs = {
  input: ChangeTierDeductibleCommitIntentInput;
};


export type MutationChangeTierDeductibleCreateIntentArgs = {
  input: ChangeTierDeductibleCreateIntentInput;
};


export type MutationChatSendFileArgs = {
  input: ChatMessageFileInput;
};


export type MutationChatSendTextArgs = {
  input: ChatMessageTextInput;
};


export type MutationContractBankSigneringCancellationInitiateArgs = {
  contractId: Scalars['UUID']['input'];
};


export type MutationConversationSendMessageArgs = {
  input: ConversationSendMessageInput;
};


export type MutationConversationStartArgs = {
  input: ConversationStartInput;
};


export type MutationFlowClaimAudioRecordingNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimAudioRecordingInput;
};


export type MutationFlowClaimConfirmEmergencyNextArgs = {
  context?: InputMaybe<Scalars['FlowContext']['input']>;
  input: FlowClaimConfirmEmergencyInput;
};


export type MutationFlowClaimContractSelectNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimContractSelectInput;
};


export type MutationFlowClaimDateOfOccurrenceNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimDateOfOccurrenceInput;
};


export type MutationFlowClaimDateOfOccurrencePlusLocationNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimDateOfOccurrencePlusLocationInput;
};


export type MutationFlowClaimFileUploadNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimFileUploadInput;
};


export type MutationFlowClaimLocationNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimLocationInput;
};


export type MutationFlowClaimPersonSelectNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimPersonSelectInput;
};


export type MutationFlowClaimPhoneNumberNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimPhoneNumberInput;
};


export type MutationFlowClaimSingleItemCheckoutNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimSingleItemCheckoutInput;
};


export type MutationFlowClaimSingleItemNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimSingleItemInput;
};


export type MutationFlowClaimStartArgs = {
  context?: InputMaybe<Scalars['FlowContext']['input']>;
  input: FlowClaimStartInput;
};


export type MutationFlowClaimSummaryNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowClaimSummaryInput;
};


export type MutationFlowTerminationDateNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowTerminationDateInput;
};


export type MutationFlowTerminationDeletionNextArgs = {
  context: Scalars['FlowContext']['input'];
  input?: InputMaybe<FlowTerminationDeletionInput>;
};


export type MutationFlowTerminationStartArgs = {
  context?: InputMaybe<Scalars['FlowContext']['input']>;
  input: FlowTerminationStartInput;
};


export type MutationFlowTerminationSurveyNextArgs = {
  context: Scalars['FlowContext']['input'];
  input: FlowTerminationSurveyInput;
};


export type MutationInsurelyInitiateIframeDataCollectionArgs = {
  input: InsurelyInitiateIframeDataCollectionInput;
};


export type MutationMemberCampaignsRedeemArgs = {
  code: Scalars['String']['input'];
};


export type MutationMemberCampaignsUnredeemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMemberDeviceRegisterArgs = {
  input: MemberDeviceRegisterInput;
};


export type MutationMemberReferralInformationCodeUpdateArgs = {
  code: Scalars['String']['input'];
};


export type MutationMemberUpdateEmailArgs = {
  input: MemberUpdateEmailInput;
};


export type MutationMemberUpdateEurobonusNumberArgs = {
  input: MemberUpdateEurobonusNumberInput;
};


export type MutationMemberUpdateLanguageArgs = {
  input: MemberUpdateLanguageInput;
};


export type MutationMemberUpdatePhoneNumberArgs = {
  input: MemberUpdatePhoneNumberInput;
};


export type MutationMemberUpdateSubscriptionPreferenceArgs = {
  subscribe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMidtermChangeIntentCommitArgs = {
  intentId: Scalars['ID']['input'];
};


export type MutationMidtermChangeIntentCreateArgs = {
  contractId: Scalars['ID']['input'];
  input: MidtermChangeIntentCreateInput;
};


export type MutationMoveIntentCommitArgs = {
  homeQuoteId?: InputMaybe<Scalars['ID']['input']>;
  intentId: Scalars['ID']['input'];
};


export type MutationMoveIntentRequestArgs = {
  input: MoveIntentRequestInput;
  intentId: Scalars['ID']['input'];
};


export type MutationPartnerWidgetInitArgs = {
  input: PartnerWidgetInitInput;
};


export type MutationPriceIntentConfirmArgs = {
  priceIntentId: Scalars['UUID']['input'];
};


export type MutationPriceIntentCreateArgs = {
  input: PriceIntentCreateInput;
};


export type MutationPriceIntentDataUpdateArgs = {
  data: Scalars['PricingFormData']['input'];
  priceIntentId: Scalars['UUID']['input'];
};


export type MutationPriceIntentExternalInsurerUpdateArgs = {
  externalInsurerId?: InputMaybe<Scalars['ID']['input']>;
  priceIntentId: Scalars['UUID']['input'];
};


export type MutationPriceIntentInsurelyUpdateArgs = {
  dataCollectionId: Scalars['String']['input'];
  priceIntentId: Scalars['UUID']['input'];
};


export type MutationProductOffersCancellationRequestedUpdateArgs = {
  productOfferIds: Array<Scalars['UUID']['input']>;
  requested: Scalars['Boolean']['input'];
};


export type MutationProductOffersStartDateUpdateArgs = {
  productOfferIds: Array<Scalars['UUID']['input']>;
  startDate: Scalars['Date']['input'];
};


export type MutationRegisterDirectDebit2Args = {
  clientContext?: InputMaybe<RegisterDirectDebitClientContext2>;
};


export type MutationSendEventBatchArgs = {
  inputList: Array<EventInput>;
};


export type MutationShopSessionCartCampaignRedeemArgs = {
  input: ShopSessionCartCampaignRedeemInput;
};


export type MutationShopSessionCartCampaignUnredeemArgs = {
  input: ShopSessionCartCampaignUnredeemInput;
};


export type MutationShopSessionCartEntriesAddArgs = {
  input?: InputMaybe<ShopSessionCartEntriesAddInput>;
};


export type MutationShopSessionCartEntriesRemoveArgs = {
  input?: InputMaybe<ShopSessionCartEntriesRemoveInput>;
};


export type MutationShopSessionCreateArgs = {
  input: ShopSessionCreateInput;
};


export type MutationShopSessionCreatePartnerArgs = {
  input?: InputMaybe<ShopSessionCreatePartnerInput>;
};


export type MutationShopSessionCustomerUpdateArgs = {
  input: ShopSessionCustomerUpdateInput;
};


export type MutationShopSessionStartSignArgs = {
  shopSessionId: Scalars['UUID']['input'];
};


export type MutationSubmitAdyenRedirection2Args = {
  req?: InputMaybe<SubmitAdyenRedirectionRequest>;
};


export type MutationSwitcherCaseCompleteArgs = {
  currentExpiryDate: Scalars['Date']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationTokenizePaymentDetails2Args = {
  req?: InputMaybe<TokenizationRequest>;
};


export type MutationTravelCertificateCreateArgs = {
  input: TravelCertificateCreateInput;
};


export type MutationUpdateConsentArgs = {
  consentGiven: Scalars['Boolean']['input'];
  trialId: Scalars['UUID']['input'];
};

export type PartnerData = {
  __typename?: 'PartnerData';
  sas?: Maybe<SasPartnerData>;
};

export type PartnerWidgetData = {
  __typename?: 'PartnerWidgetData';
  externalRequestId: Scalars['String']['output'];
  trialInfo?: Maybe<PartnerWidgetTrialInfo>;
};

export type PartnerWidgetInitInput = {
  countryCode: CountryCode;
  externalMemberId?: InputMaybe<Scalars['UUID']['input']>;
  externalRequestId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['UUID']['input'];
};

export type PartnerWidgetTrial = {
  __typename?: 'PartnerWidgetTrial';
  trialContract: TrialContract;
};

export type PartnerWidgetTrialInfo = {
  __typename?: 'PartnerWidgetTrialInfo';
  birthDate: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['Date']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  insuranceData: Scalars['JSON']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
};

/**
 * A pending contract is a proto-contract that has yet to become a fully fledged insurance. It usually means it is meant
 * to be activated when an existing external insurance has been cancelled (switching).
 *
 * It is split into its own type, because they are not "real" insurances until they become active ones.
 */
export type PendingContract = {
  __typename?: 'PendingContract';
  /** Same as `Contract.currentAgreement.displayItems`. */
  displayItems: Array<AgreementDisplayItem>;
  /** Same as `Contract.exposureDisplayName`. */
  exposureDisplayName: Scalars['String']['output'];
  /**
   * A value indicating whether Hedvig will help out with the cancellation of the member's existing insurance (true)
   * or if the member have to cancel it themselves and get back to us with a requested start date (false).
   */
  externalInsuranceCancellationHandledByHedvig: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** Same as `Contract.currentAgreement.premium`. */
  premium: Money;
  /** Same as `Contract.currentAgreement.productVariant`. */
  productVariant: ProductVariant;
};

export type Peril = {
  __typename?: 'Peril';
  colorCode?: Maybe<Scalars['String']['output']>;
  covered: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  exceptions: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  city: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postalNumber: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
};

export type PersonalInformationInput = {
  personalNumber: Scalars['String']['input'];
};

export type PriceIntent = {
  __typename?: 'PriceIntent';
  /** Submitted user form data. */
  data: Scalars['PricingFormData']['output'];
  /** When there are offers, pick a suitable default one.  Used in CRM where we want to present single offer per price intent */
  defaultOffer?: Maybe<ProductOffer>;
  /** The person's current insurance company */
  externalInsurer?: Maybe<ExternalInsurer>;
  /** The id of the price intent. */
  id: Scalars['UUID']['output'];
  insurely?: Maybe<PriceIntentInsurely>;
  /** Optional notifications related to priceIntent. Examples: cancellation advice regarding current insurance, note about car not being currently owned by customer */
  notifications?: Maybe<Array<PriceIntentNotification>>;
  /** The resulting product offers generated by inputting data and confirming the intent. */
  offers: Array<ProductOffer>;
  /** The product associated to this price intent */
  product: Product;
  /** Data submitted in other places or inferred from other data points */
  suggestedData: Scalars['PricingFormData']['output'];
};

export enum PriceIntentAnimal {
  Cat = 'CAT',
  Dog = 'DOG'
}

export type PriceIntentAnimalBreed = {
  __typename?: 'PriceIntentAnimalBreed';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMixedBreed: Scalars['Boolean']['output'];
};

export type PriceIntentCreateInput = {
  /** The human readable, logical name that identifies the product. I.e. `SE_APARTMENT_BRF` or similar. */
  productName: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type PriceIntentFilters = {
  uniqueConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PriceIntentInsurely = {
  __typename?: 'PriceIntentInsurely';
  configName: Scalars['ID']['output'];
  partner: Scalars['ID']['output'];
};

export type PriceIntentMutationOutput = {
  __typename?: 'PriceIntentMutationOutput';
  priceIntent?: Maybe<PriceIntent>;
  userError?: Maybe<UserError>;
};

export type PriceIntentNotification = {
  __typename?: 'PriceIntentNotification';
  /** Localized text to be shown to a user */
  message: Scalars['String']['output'];
};

/**
 * A `Product` is a data type representing a group of insurances that share certain characteristics and are packaged
 * together from the user perspective as a single entry on the store.
 *
 * The user will view it and think of it as a specific insurance, but under the hood it can be ultimately translated
 * into different `ProductVariant`s and ultimately different specific insurances depending on the data sent in
 * by the user in the `PriceIntent`.
 */
export type Product = {
  __typename?: 'Product';
  /** URL path of product category page (if applicable). */
  categoryPageLink?: Maybe<Scalars['String']['output']>;
  /** Localized name of the product in long form. */
  displayNameFull: Scalars['String']['output'];
  /** Localized name of the product in short form. */
  displayNameShort: Scalars['String']['output'];
  /** A list of the external insurers valid for this specific product. */
  externalInsurers: Array<ExternalInsurer>;
  /** The featured image asset associated with this product. */
  featuredImage?: Maybe<StoryblokImageAsset>;
  id: Scalars['ID']['output'];
  /** Indicates if the product can be bought multiple times or not. */
  multiple?: Maybe<Scalars['Boolean']['output']>;
  /** A unique, human readable, identifier of the product */
  name: Scalars['String']['output'];
  /** URL path of product detail page. */
  pageLink: Scalars['String']['output'];
  /** The pillow image asset associated with this product. */
  pillowImage: StoryblokImageAsset;
  /** URL path of price calculator page. */
  priceCalculatorPageLink?: Maybe<Scalars['String']['output']>;
  /** Localized tagline of the product. */
  tagline: Scalars['String']['output'];
  /** Return all the possible `ProductVariants` that can come out of this Product */
  variants: Array<ProductVariant>;
};

export type ProductOffer = {
  __typename?: 'ProductOffer';
  /** Values related to cancellation/switching of their existing other insurance. */
  cancellation: ExternalInsuranceCancellation;
  /** The cost of this offer */
  cost: ProductOfferCost;
  /** The deductible description of this offer, if there is one. */
  deductible?: Maybe<ProductOfferDeductible>;
  /** Data for presenting offer summary */
  displayItems: Array<ProductOfferDisplayItem>;
  /** Exposure (insured object) summary */
  exposure: ProductOfferExposure;
  /** The id of this item, which can be used to add to cart. */
  id: Scalars['UUID']['output'];
  /** The form data used to generate the offer */
  priceIntentData: Scalars['PricingFormData']['output'];
  /** ID of original priceIntent. Some offers (ex. recommendations) come from other sources and don't have priceIntent */
  priceIntentId?: Maybe<Scalars['UUID']['output']>;
  /** Information about a price match with an external insurance */
  priceMatch?: Maybe<ProductOfferPriceMatch>;
  /** The product this offer is tied to. */
  product: Product;
  /** The start date of the insurance */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The variant of product that this offer resembles. */
  variant: ProductVariant;
};

export type ProductOfferCost = {
  __typename?: 'ProductOfferCost';
  /** How much price was reduced. */
  discount: Money;
  discountMonths: Scalars['Int']['output'];
  /** Original price. */
  gross: Money;
  /** Price you will pay after discount. */
  net: Money;
};

export type ProductOfferDeductible = {
  __typename?: 'ProductOfferDeductible';
  displayName: Scalars['String']['output'];
  tagline: Scalars['String']['output'];
};

/** Formatted and localized entry of pricing data */
export type ProductOfferDisplayItem = {
  __typename?: 'ProductOfferDisplayItem';
  /** Localized field title */
  displayTitle: Scalars['String']['output'];
  /** Localized display value */
  displayValue: Scalars['String']['output'];
  /** Field name as represented in PricingFormData */
  key: Scalars['String']['output'];
  /** Field technical value.  Clients may use it to build better visual representation than text-only displayValue */
  value: Scalars['JSON']['output'];
};

/** Generic summary of insured object */
export type ProductOfferExposure = {
  __typename?: 'ProductOfferExposure';
  /** Ex. 'Fakestreet 124 * You+1' for home */
  displayNameFull: Scalars['String']['output'];
  /** Ex. 'REG 123' for car */
  displayNameShort: Scalars['String']['output'];
};

export type ProductOfferPriceMatch = {
  __typename?: 'ProductOfferPriceMatch';
  externalInsurer: ExternalInsurer;
  externalPrice: Money;
  priceReduction: Money;
};

export type ProductOffersMutationOutput = {
  __typename?: 'ProductOffersMutationOutput';
  productOffers: Array<ProductOffer>;
  userError?: Maybe<UserError>;
};

/**
 * A recommendation is a suggestion by the platform for a specific product that might be of interest
 * to the user based on input so far.
 *
 * Some recommendations even have a pre-packaged `ProductOffer` that can be added to the cart immediately,
 * if the user has input enough information to generate it.
 */
export type ProductRecommendation = {
  __typename?: 'ProductRecommendation';
  offer?: Maybe<ProductOffer>;
  product: Product;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  /**
   * Get a list of 'common claim descriptions' for this product variant.
   *
   * This can contain content such as 'sick abroad' or 'broken phone' for a home insurance, for instance.
   * @deprecated Should be implemented in clients or owned by another sub-graph
   */
  commonClaimDescriptions: Array<CommonClaimDescription>;
  /** The full name of this product variant. */
  displayName: Scalars['String']['output'];
  /** A shorter name of that highlights in which way it distinguishes itself from other similar insurances. */
  displayNameSubtype: Scalars['String']['output'];
  /** A display name of the tier for this variant. */
  displayNameTier?: Maybe<Scalars['String']['output']>;
  /**
   * A longer/more descriptive display name of the tier for this variant.
   * @deprecated Use tierDescription instead
   */
  displayNameTierLong?: Maybe<Scalars['String']['output']>;
  documents: Array<InsuranceDocument>;
  insurableLimits: Array<InsurableLimit>;
  partner?: Maybe<Scalars['String']['output']>;
  perils: Array<Peril>;
  /**
   * A `ProductVariant` is identified by its terms version, which is the more technical
   * name for a unique incarnation of our insurances (products) at a point in time.
   */
  termsVersion: Scalars['ID']['output'];
  /** A description of the tier for this variant. */
  tierDescription?: Maybe<Scalars['String']['output']>;
  typeOfContract: Scalars['String']['output'];
};

/** Root of coverage comparison result */
export type ProductVariantComparison = {
  __typename?: 'ProductVariantComparison';
  /** Rows represent Peril-specific coverage */
  rows: Array<ProductVariantComparisonRow>;
  /** Every column is represented by matching ProductVariant */
  variantColumns: Array<ProductVariant>;
};

export type ProductVariantComparisonCell = {
  __typename?: 'ProductVariantComparisonCell';
  /** Coverage limit if known and configured, presented as formatted text */
  coverageText?: Maybe<Scalars['String']['output']>;
  /** If peril is covered */
  isCovered: Scalars['Boolean']['output'];
};

export type ProductVariantComparisonRow = {
  __typename?: 'ProductVariantComparisonRow';
  /** Coverage per tier */
  cells: Array<ProductVariantComparisonCell>;
  /** Color */
  colorCode?: Maybe<Scalars['String']['output']>;
  /** Peril description */
  description: Scalars['String']['output'];
  /** Peril title */
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Returns all the available payments methods before the client requests a tokenization */
  availablePaymentMethods2: AvailablePaymentMethodsResponse;
  availableProducts: Array<Product>;
  carTrial?: Maybe<TrialExtension>;
  chat: Chat;
  /** Resolve a single contract by its ID. Requires the caller to be a member owning said contract. */
  contract: Contract;
  /**
   * Return a conversation for a given ID.
   *
   * Note that this can return null if `Mutation.conversationStart` has not been called with this ID.
   */
  conversation?: Maybe<Conversation>;
  /**
   * Gets the currently authenticated member. This is the only valid way to query a `Member` type, and it is based
   * on the input Authorization header.
   */
  currentMember: Member;
  entrypointGroups: Array<EntrypointGroup>;
  entrypointSearch: Array<Entrypoint>;
  personalInformation?: Maybe<PersonalInformation>;
  priceIntent: PriceIntent;
  priceIntentAvailableBreeds: Array<PriceIntentAnimalBreed>;
  product?: Maybe<Product>;
  productVariant?: Maybe<ProductVariant>;
  /** Compare perils and peril-specific coverage limits across tiers of a product, identified by termsVersions */
  productVariantComparison: ProductVariantComparison;
  shopSession: ShopSession;
  /**
   * Outcome of shopSession.  Requires authentication
   *
   * Available forever, unlike shopSession which becomes hidden some time after creation
   */
  shopSessionOutcome?: Maybe<ShopSessionOutcome>;
  shopSessionSigning: ShopSessionSigning;
  switcherCase: SwitcherCase;
  /** Resolve a single Trial contract by its ID. Does NOT require the caller to be a member owning said contract. */
  trialContract: TrialContract;
};


export type QueryAvailableProductsArgs = {
  partnerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCarTrialArgs = {
  contractId: Scalars['UUID']['input'];
};


export type QueryChatArgs = {
  until?: InputMaybe<Scalars['Instant']['input']>;
};


export type QueryContractArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryConversationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEntrypointGroupsArgs = {
  type: EntrypointType;
};


export type QueryEntrypointSearchArgs = {
  input?: InputMaybe<EntrypointSearchInput>;
};


export type QueryPersonalInformationArgs = {
  input: PersonalInformationInput;
};


export type QueryPriceIntentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPriceIntentAvailableBreedsArgs = {
  animal: PriceIntentAnimal;
};


export type QueryProductArgs = {
  partnerName?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
};


export type QueryProductVariantArgs = {
  termsVersion: Scalars['ID']['input'];
};


export type QueryProductVariantComparisonArgs = {
  termsVersions: Array<Scalars['ID']['input']>;
};


export type QueryShopSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryShopSessionOutcomeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryShopSessionSigningArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySwitcherCaseArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTrialContractArgs = {
  id: Scalars['UUID']['input'];
};

/** A type describing a redeemed campaign. */
export type RedeemedCampaign = {
  __typename?: 'RedeemedCampaign';
  /** The code the user input to attach this campaign. */
  code: Scalars['String']['output'];
  /** A user-readable description of this campaign. */
  description: Scalars['String']['output'];
  /** The discount information from this campaign. */
  discount: CampaignDiscount;
  /**
   * The expiry of this campaign, this is non-null if the following is true:
   * - It is a kind of campaign that has an expiry (i.e. NOT a referral)
   * - It has been successfully redeemed by a signed member (i.e. not only in a ShopSession)
   */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Lists the currently active contracts that this campaign is applicable to.
   *
   * If this is applicable to ALL insurances, `null` is returned. Otherwise we return the contracts here.
   *
   * NOTE: The implementation of this is rather cursed, and thus this should be used sparingly.
   */
  onlyApplicableToContracts?: Maybe<Array<Contract>>;
  /** REFERRAL (you were invited by a friend) or VOUCHER (this is some kind of limited discount or similar) */
  type: RedeemedCampaignType;
};

export enum RedeemedCampaignType {
  /** Invited by a friend (Hedvig Forever) */
  Referral = 'REFERRAL',
  /** Some kind of discount usually created in Hope. */
  Voucher = 'VOUCHER'
}

export type RegisterDirectDebitClientContext2 = {
  failureUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type SasPartnerData = {
  __typename?: 'SasPartnerData';
  eligible: Scalars['Boolean']['output'];
  eurobonusNumber?: Maybe<Scalars['String']['output']>;
};

export type ShopSession = {
  __typename?: 'ShopSession';
  /** The Cart value of this shop session, carrying offers currently awaiting checkout. */
  cart: Cart;
  /** The country this session was created with. */
  countryCode: CountryCode;
  /** Creation timestamp. */
  created: Scalars['DateTime']['output'];
  /** The currency associated with the country of the session. */
  currencyCode: CurrencyCode;
  /**
   * The customer value of the session. Can be updated through a mutation.
   *
   * The initial value is:
   * - null if the session was created without authentication
   * - non-null if the session was created as a logged in member
   */
  customer?: Maybe<ShopSessionCustomer>;
  /** Feature flags and experiment eligibility */
  experiments?: Maybe<ShopSessionExperiments>;
  id: Scalars['UUID']['output'];
  /** The outcome of a signed shop-session. Requires authentication. */
  outcome?: Maybe<ShopSessionOutcome>;
  partnerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated To be removed with old widget web app. New implementation uses partnerWidgetTrial for trials and generic info everywhere else */
  partnerWidgetData?: Maybe<PartnerWidgetData>;
  /** Trial-specific info for trial insurances supported in widget flows (no Car Trials, for example) */
  partnerWidgetTrial?: Maybe<PartnerWidgetTrial>;
  /** The full list of created price intents in this session */
  priceIntents: Array<PriceIntent>;
  /** Product recommendations for the member (this field is authenticated). */
  recommendations: Array<ProductRecommendation>;
  /** Indicates when this shop session was signed successfully. Not set if signing attempts fail. */
  signedAt: Scalars['DateTime']['output'];
  /** Website URLs for API operations on this session */
  urls: ShopSessionUrls;
};


export type ShopSessionPriceIntentsArgs = {
  filters?: InputMaybe<PriceIntentFilters>;
};

export type ShopSessionCartCampaignRedeemInput = {
  code: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartCampaignUnredeemInput = {
  campaignId: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartEntriesAddInput = {
  offerIds: Array<Scalars['UUID']['input']>;
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartEntriesRemoveInput = {
  offerIds: Array<Scalars['UUID']['input']>;
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCreateInput = {
  attributedTo?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
};

export type ShopSessionCreatePartnerInput = {
  /** Optional campaign code if partner configuration support this */
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
  /** Used for matching trial data with earlier trial created via backed API */
  externalMemberId?: InputMaybe<Scalars['String']['input']>;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Known partner name, case-insensitive */
  partnerName: Scalars['String']['input'];
  /** Will be used for webhooks if provided. Otherwise random UUID will be generated */
  partnerRequestId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The customer is a type containing information about the user interacting with the Store.
 *
 * This can either contain data actively provided through the customer update mutation, but also data automatically
 * looked up based on things like ssn.
 *
 * This data will ultimately be translated into `holder` information of the underlying insurance.
 */
export type ShopSessionCustomer = {
  __typename?: 'ShopSessionCustomer';
  /**
   * The list of fields that need to be added in order to sign properly.
   *
   * Can be updated through `Mutation.shopSessionCustomerUpdate`.
   */
  missingFields: Array<ShopSessionCustomerMissingField>;
  /** The personal number of the customer. Can be used for looking up other information. */
  ssn?: Maybe<Scalars['String']['output']>;
};

export enum ShopSessionCustomerMissingField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  PhoneNumber = 'PHONE_NUMBER'
}

export type ShopSessionCustomerUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  shopSessionId: Scalars['UUID']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type ShopSessionExperiments = {
  __typename?: 'ShopSessionExperiments';
  bundleDiscount?: Maybe<Scalars['Boolean']['output']>;
};

export type ShopSessionMutationOutput = {
  __typename?: 'ShopSessionMutationOutput';
  shopSession?: Maybe<ShopSession>;
  userError?: Maybe<UserError>;
};

/**
 * Contains relevant post-sign objects of the shop-session. After a shop session is completed, this object is added to
 * the shop-session and can be used to perform necessary post-sign actions, such as external insurance cancellation.
 */
export type ShopSessionOutcome = {
  __typename?: 'ShopSessionOutcome';
  /**
   * List all the properly created contracts from the completed shop session.
   *
   * Note that this will not contain and `PendingContract`s.
   */
  createdContracts: Array<Contract>;
  id: Scalars['UUID']['output'];
};

export type ShopSessionSigning = {
  __typename?: 'ShopSessionSigning';
  /** A value that will be present if status is SIGNED. */
  completion?: Maybe<ShopSessionSigningCompletion>;
  id: Scalars['UUID']['output'];
  /**
   * The token that can be used to trigger an immediate switch to the BankID app on the same device.
   * @deprecated Use `seBankidProperties` instead
   */
  seBankidAutoStartToken?: Maybe<Scalars['String']['output']>;
  /**
   * The data to put inside a QR code and to be scanned by the BankID app. Should be polled
   * and updated continuously.
   * @deprecated Use `seBankidProperties` instead
   */
  seBankidLiveQrCodeData?: Maybe<Scalars['String']['output']>;
  /** Properties present if this is a signing through Swedish BankID. */
  seBankidProperties?: Maybe<ShopSessionSigningSeBankidProperties>;
  /** The status of this signing. */
  status: ShopSessionSigningStatus;
  /** A value that will be present if status is FAILED. */
  userError?: Maybe<UserError>;
};

export type ShopSessionSigningCompletion = {
  __typename?: 'ShopSessionSigningCompletion';
  /**
   * A value that can be used to create an accessToken/refreshToken pair from the auth service. This is used
   * to let the user become a fully logged in member automatically after signing their insurance.
   */
  authorizationCode: Scalars['String']['output'];
};

export type ShopSessionSigningMutationOutput = {
  __typename?: 'ShopSessionSigningMutationOutput';
  signing?: Maybe<ShopSessionSigning>;
  userError?: Maybe<UserError>;
};

export type ShopSessionSigningSeBankidProperties = {
  __typename?: 'ShopSessionSigningSeBankidProperties';
  /** The token that can be used to trigger an immediate switch to the BankID app on the same device. */
  autoStartToken: Scalars['String']['output'];
  /**
   * A boolean value that will flip to true if we detect that the session has been registered in the BankID app.
   * This either happens through auto-start or by scanning the live QR code.
   */
  bankidAppOpened: Scalars['Boolean']['output'];
  /**
   * The data to put inside a QR code and to be scanned by the BankID app. Should be polled
   * and updated continuously.
   */
  liveQrCodeData: Scalars['String']['output'];
};

export enum ShopSessionSigningStatus {
  /**
   * This state indicates that the signing is accepted, but is actively being rolled out through the system.
   * The front-end can use this value to display progress feedback to the user if wanted.
   */
  Creating = 'CREATING',
  /** The signing failed for some reason. Could be that it was cancelled by the user or something else. */
  Failed = 'FAILED',
  /** Signing still in-process, and is awaiting action from the user, such as using an external BankID service. */
  Pending = 'PENDING',
  /** This means the signing has completed successfully. */
  Signed = 'SIGNED'
}

export type ShopSessionUrls = {
  __typename?: 'ShopSessionUrls';
  /**
   * Link to retargeting flow for CRM
   *
   * See https://github.com/HedvigInsurance/racoon/blob/main/apps/store/src/features/retargeting/README.md
   */
  retargeting: Scalars['String']['output'];
};

export type SickAbroadAction = {
  __typename?: 'SickAbroadAction';
  partners: Array<SickAbroadPartner>;
};

export type SickAbroadPartner = {
  __typename?: 'SickAbroadPartner';
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['Url']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['Url']['output']>;
};

export type StoryblokImageAsset = {
  __typename?: 'StoryblokImageAsset';
  alt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
};

export type SubmitAdyenRedirectionRequest = {
  md: Scalars['String']['input'];
  pares: Scalars['String']['input'];
};

export type SubmitAdyenRedirectionResponse = {
  __typename?: 'SubmitAdyenRedirectionResponse';
  resultCode: Scalars['String']['output'];
};

/**
 * Represents a case of switching, pointing towards a soon-to-be insurance Contract on our platform.
 *
 * If it is not completed, it can be by calling `Mutation.switcherCaseComplete`.
 */
export type SwitcherCase = {
  __typename?: 'SwitcherCase';
  id: Scalars['UUID']['output'];
  /** If true, this can no longer be changed. */
  isCompleted: Scalars['Boolean']['output'];
};

export type SwitcherCaseMutationOutput = {
  __typename?: 'SwitcherCaseMutationOutput';
  switcherCase?: Maybe<SwitcherCase>;
  userError?: Maybe<UserError>;
};

export enum TokenizationChannel {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type TokenizationRequest = {
  browserInfo?: InputMaybe<BrowserInfo>;
  channel: TokenizationChannel;
  paymentMethodDetails: Scalars['PaymentMethodDetails']['input'];
  returnUrl: Scalars['String']['input'];
};

export type TokenizationResponse = TokenizationResponseAction | TokenizationResponseFinished;

export type TokenizationResponseAction = {
  __typename?: 'TokenizationResponseAction';
  action: Scalars['CheckoutPaymentsAction']['output'];
};

export type TokenizationResponseFinished = {
  __typename?: 'TokenizationResponseFinished';
  resultCode: Scalars['String']['output'];
  tokenizationResult: TokenizationResultType;
};

export enum TokenizationResultType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type TravelCertificate = {
  __typename?: 'TravelCertificate';
  endDate?: Maybe<Scalars['Date']['output']>;
  expiryDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  signedUrl: Scalars['Url']['output'];
  startDate: Scalars['Date']['output'];
};

export type TravelCertificateContractSpecification = {
  __typename?: 'TravelCertificateContractSpecification';
  contractId: Scalars['ID']['output'];
  location?: Maybe<Location>;
  maxDurationDays: Scalars['Int']['output'];
  maxStartDate: Scalars['Date']['output'];
  minStartDate: Scalars['Date']['output'];
  numberOfCoInsured: Scalars['Int']['output'];
};

export type TravelCertificateCreateCoInsured = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  fullName: Scalars['String']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type TravelCertificateCreateInput = {
  coInsured: Array<TravelCertificateCreateCoInsured>;
  contractId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isMemberIncluded: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};

export type TravelCertificateInfoSpecification = {
  __typename?: 'TravelCertificateInfoSpecification';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TravelCertificateSpecification = {
  __typename?: 'TravelCertificateSpecification';
  contractSpecifications: Array<TravelCertificateContractSpecification>;
  /** @deprecated Not used anymore, will be removed */
  infoSpecifications: Array<TravelCertificateInfoSpecification>;
};

/**
 * A TrialContract is a contract for which it's insuranceType is considered pending. This is a
 * special simplified contract view of those contracts, which can be fetched without being member-authenticated.
 */
export type TrialContract = {
  __typename?: 'TrialContract';
  /** Same as `Contract.currentAgreement.activeFrom`. */
  activeFrom: Scalars['Date']['output'];
  /** Same as `Contract.currentAgreement.activeTo`. */
  activeTo?: Maybe<Scalars['Date']['output']>;
  /** Same as `Contract.currentAgreement.displayItems`. */
  displayItems: Array<AgreementDisplayItem>;
  /** Same as `Contract.exposureDisplayName`. */
  exposureDisplayName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  /** Same as `Contract.currentAgreement.premium`. */
  premium: Money;
  /** Same as `Contract.currentAgreement.productVariant`. */
  productVariant: ProductVariant;
  /** Same as `Contract.terminationDate`. */
  terminationDate?: Maybe<Scalars['Date']['output']>;
};

export type TrialExtension = {
  __typename?: 'TrialExtension';
  collectConsent: Scalars['Boolean']['output'];
  consentGiven: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  priceIntent: PriceIntent;
  shopSession: ShopSession;
  trialContract: TrialContract;
};

/**
 * A data type returned by certain mutations that is meant to carry user-displayable and localized
 * messages.
 *
 * The errors are usually translated through the `Hedvig-Language` header.
 */
export type UserError = {
  __typename?: 'UserError';
  message?: Maybe<Scalars['String']['output']>;
};

export type ValueArray = {
  __typename?: 'ValueArray';
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type ValueBoolean = {
  __typename?: 'ValueBoolean';
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type ValueDate = {
  __typename?: 'ValueDate';
  value?: Maybe<Scalars['Date']['output']>;
};

export type ValueInteger = {
  __typename?: 'ValueInteger';
  value?: Maybe<Scalars['Int']['output']>;
};

export type ValueString = {
  __typename?: 'ValueString';
  value?: Maybe<Scalars['String']['output']>;
};

export type ValueType = ValueArray | ValueBoolean | ValueDate | ValueInteger | ValueString;

export type SwitcherCaseCompleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  currentExpiryDate: Scalars['Date']['input'];
}>;


export type SwitcherCaseCompleteMutation = { __typename?: 'Mutation', switcherCaseComplete: { __typename?: 'SwitcherCaseMutationOutput', switcherCase?: { __typename?: 'SwitcherCase', id: string, isCompleted: boolean } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type SwitcherCaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SwitcherCaseQuery = { __typename?: 'Query', switcherCase: { __typename?: 'SwitcherCase', id: string, isCompleted: boolean } };

export type ProductVariantFragment = { __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', type: InsurableLimitType, label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> };

export type ProductDataFullFragment = { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string }, variants: Array<{ __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', type: InsurableLimitType, label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> }> };

export type ProductDataQueryVariables = Exact<{
  productName: Scalars['String']['input'];
  partnerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductDataQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string }, variants: Array<{ __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', type: InsurableLimitType, label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> }> } | null };

export type ProductRecommendationsQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ProductRecommendationsQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, recommendations: Array<{ __typename?: 'ProductRecommendation', product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null }, offer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } } | null }> } };

export type ProductRecommendationFragment = { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null };

export type OfferRecommendationFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } };

export type RecommendationFragment = { __typename?: 'ProductRecommendation', product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null }, offer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } } | null };

export type CarDealershipRemoveAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  removeOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  addOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CarDealershipRemoveAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', cart: { __typename?: 'Cart', entries: Array<{ __typename?: 'ProductOffer', id: string }> } } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', cart: { __typename?: 'Cart', entries: Array<{ __typename?: 'ProductOffer', id: string }> } } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CarTrialExtensionQueryVariables = Exact<{
  contractId: Scalars['UUID']['input'];
}>;


export type CarTrialExtensionQuery = { __typename?: 'Query', carTrial?: { __typename?: 'TrialExtension', id: string, collectConsent: boolean, consentGiven: boolean, priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string } }, defaultOffer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } } | null }, shopSession: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null }, trialContract: { __typename?: 'TrialContract', id: string, exposureDisplayName: string, terminationDate?: any | null, activeFrom: any, activeTo?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> } } } | null };

export type PriceIntentCarTrialExtensionFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string } }, defaultOffer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } } | null };

export type PriceIntentDataUpdateCarMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
}>;


export type PriceIntentDataUpdateCarMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type TrialContractFragment = { __typename?: 'TrialContract', id: string, exposureDisplayName: string, terminationDate?: any | null, activeFrom: any, activeTo?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> } };

export type MemberAreaMemberInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberAreaMemberInfoQuery = { __typename?: 'Query', currentMember: { __typename?: 'Member', firstName: string, lastName: string, email: string, ssn?: string | null, activeContracts: Array<{ __typename?: 'Contract', id: string, exposureDisplayName: string, currentAgreement: { __typename?: 'Agreement', activeFrom: any, activeTo: any, certificateUrl?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, typeOfContract: string, termsVersion: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string }>, perils: Array<{ __typename?: 'Peril', colorCode?: string | null, covered: Array<string>, description: string, exceptions: Array<string>, title: string }> } } }>, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus, connection?: { __typename?: 'MemberPaymentConnection', descriptor: string, displayName: string } | null }, insuranceCost: { __typename?: 'MemberInsuranceCost', freeUntil?: any | null, monthlyDiscount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyNet: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } };

export type MemberContractFragment = { __typename?: 'Contract', id: string, exposureDisplayName: string, currentAgreement: { __typename?: 'Agreement', activeFrom: any, activeTo: any, certificateUrl?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, typeOfContract: string, termsVersion: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string }>, perils: Array<{ __typename?: 'Peril', colorCode?: string | null, covered: Array<string>, description: string, exceptions: Array<string>, title: string }> } } };

export type MemberInsuranceCostFragment = { __typename?: 'MemberInsuranceCost', freeUntil?: any | null, monthlyDiscount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyNet: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } };

export type TravelCertificateCreateMutationVariables = Exact<{
  input: TravelCertificateCreateInput;
}>;


export type TravelCertificateCreateMutation = { __typename?: 'Mutation', travelCertificateCreate: { __typename?: 'TravelCertificate', id: string, signedUrl: any } };

export type CartEntriesAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CartEntriesAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionRetargetingQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionRetargetingQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, cart: { __typename?: 'Cart', campaignsEnabled: boolean, entries: Array<{ __typename?: 'ProductOffer', id: string }> }, priceIntents: Array<{ __typename?: 'PriceIntent', id: string, data: any, defaultOffer?: { __typename?: 'ProductOffer', id: string, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number } } } | null, product: { __typename?: 'Product', name: string } }> } };

export type RetargetingPriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, defaultOffer?: { __typename?: 'ProductOffer', id: string, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number } } } | null, product: { __typename?: 'Product', name: string } };

export type WidgetPriceIntentQueryVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type WidgetPriceIntentQuery = { __typename?: 'Query', priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, product: { __typename?: 'Product', displayNameShort: string, id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', src: string, alt?: string | null } }, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } };

export type WidgetPriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, product: { __typename?: 'Product', displayNameShort: string, id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', src: string, alt?: string | null } }, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null };

export type CartEntryAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type CartEntryAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartEntryRemoveMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type CartEntryRemoveMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartEntryReplaceMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  removeOfferId: Scalars['UUID']['input'];
  addOfferId: Scalars['UUID']['input'];
}>;


export type CartEntryReplaceMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartFragment = { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> };

export type RedeemedCampaignFragment = { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } };

export type RedeemCampaignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  code: Scalars['String']['input'];
}>;


export type RedeemCampaignMutation = { __typename?: 'Mutation', shopSessionCartCampaignRedeem: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type UnredeemCampaignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  campaignId: Scalars['String']['input'];
}>;


export type UnredeemCampaignMutation = { __typename?: 'Mutation', shopSessionCartCampaignUnredeem: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ContractQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContractQuery = { __typename?: 'Query', contract: { __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } }, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null } };

export type BankSigneringInitMutationVariables = Exact<{
  contractId: Scalars['UUID']['input'];
}>;


export type BankSigneringInitMutation = { __typename?: 'Mutation', contractBankSigneringCancellationInitiate: { __typename?: 'Contract', id: string, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null } };

export type ContractExternalInsuranceCancellationFragment = { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null };

export type CurrentMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMemberQuery = { __typename?: 'Query', currentMember: { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null } };

export type ExternalInsurerUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  externalInsurerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExternalInsurerUpdateMutation = { __typename?: 'Mutation', priceIntentExternalInsurerUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ExternalInsurersQueryVariables = Exact<{
  productName: Scalars['String']['input'];
}>;


export type ExternalInsurersQuery = { __typename?: 'Query', product?: { __typename?: 'Product', externalInsurers: Array<{ __typename?: 'ExternalInsurer', id: string, displayName: string }> } | null };

export type InsuranceDocumentFragment = { __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string };

export type InsurelyDataCollectionCreateMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  partner: Scalars['String']['input'];
}>;


export type InsurelyDataCollectionCreateMutation = { __typename?: 'Mutation', insurelyInitiateIframeDataCollection: { __typename?: 'InsurelyInitiateIframeDataCollectionOutput', dataCollectionId: string } };

export type MemberFragment = { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null };

export type PerilFragment = { __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null };

export type PriceIntentQueryVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type PriceIntentQuery = { __typename?: 'Query', priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } };

export type PriceIntentAvailableBreedsQueryVariables = Exact<{
  animal: PriceIntentAnimal;
}>;


export type PriceIntentAvailableBreedsQuery = { __typename?: 'Query', priceIntentAvailableBreeds: Array<{ __typename?: 'PriceIntentAnimalBreed', id: string, displayName: string, isMixedBreed: boolean }> };

export type CancellationRequestedUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  requested: Scalars['Boolean']['input'];
}>;


export type CancellationRequestedUpdateMutation = { __typename?: 'Mutation', productOffersCancellationRequestedUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentConfirmMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type PriceIntentConfirmMutation = { __typename?: 'Mutation', priceIntentConfirm: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentCreateMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
}>;


export type PriceIntentCreateMutation = { __typename?: 'Mutation', priceIntentCreate: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } };

export type PriceIntentDataUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
  customer: ShopSessionCustomerUpdateInput;
}>;


export type PriceIntentDataUpdateMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null };

export type PriceIntentInsurelyUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  dataCollectionId: Scalars['String']['input'];
}>;


export type PriceIntentInsurelyUpdateMutation = { __typename?: 'Mutation', priceIntentInsurelyUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentUpdateAndConfirmMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
}>;


export type PriceIntentUpdateAndConfirmMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, priceIntentConfirm: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink?: string | null }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentsQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type PriceIntentsQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, cart: { __typename?: 'Cart', entries: Array<{ __typename?: 'ProductOffer', id: string }> }, priceIntents: Array<{ __typename?: 'PriceIntent', id: string, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }> } };

export type ProductMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductMetadataQuery = { __typename?: 'Query', availableProducts: Array<{ __typename?: 'Product', id: string, name: string, displayNameShort: string, displayNameFull: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, categoryPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }> };

export type ProductFragment = { __typename?: 'Product', id: string, name: string, displayNameShort: string, displayNameFull: string, tagline: string, pageLink: string, priceCalculatorPageLink?: string | null, categoryPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } };

export type ProductOfferFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } };

export type SasEurobonusNumberUpdateMutationVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type SasEurobonusNumberUpdateMutation = { __typename?: 'Mutation', memberUpdateEurobonusNumber: { __typename?: 'MemberMutationOutput', member?: { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null } | null } };

export type ShopSessionQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } };

export type ShopSessionCreateMutationVariables = Exact<{
  countryCode: CountryCode;
  attributedTo?: InputMaybe<Scalars['String']['input']>;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopSessionCreateMutation = { __typename?: 'Mutation', shopSessionCreate: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } };

export type ShopSessionCustomerFragment = { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null };

export type ShopSessionCustomerUpdateMutationVariables = Exact<{
  input: ShopSessionCustomerUpdateInput;
}>;


export type ShopSessionCustomerUpdateMutation = { __typename?: 'Mutation', shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionFragment = { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, entries: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null };

export type ShopSessionOutcomeQueryVariables = Exact<{
  shopSessionOutcomeId: Scalars['UUID']['input'];
}>;


export type ShopSessionOutcomeQuery = { __typename?: 'Query', shopSessionOutcome?: { __typename?: 'ShopSessionOutcome', id: string, createdContracts: Array<{ __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } }, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null }> } | null };

export type ShopSessionOutcomeFragment = { __typename?: 'ShopSessionOutcome', id: string, createdContracts: Array<{ __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } }, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null }> };

export type ShopSessionOutcomeIdQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionOutcomeIdQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, outcome?: { __typename?: 'ShopSessionOutcome', id: string } | null } };

export type ShopSessionSigningQueryVariables = Exact<{
  shopSessionSigningId: Scalars['UUID']['input'];
}>;


export type ShopSessionSigningQuery = { __typename?: 'Query', shopSessionSigning: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionSigningFragment = { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null };

export type ShopSessionStartSignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionStartSignMutation = { __typename?: 'Mutation', shopSessionStartSign: { __typename?: 'ShopSessionSigningMutationOutput', signing?: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type StartDateUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  startDate: Scalars['Date']['input'];
}>;


export type StartDateUpdateMutation = { __typename?: 'Mutation', productOffersStartDateUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink?: string | null, displayNameShort: string, displayNameFull: string, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', typeOfContract: string, displayName: string, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, bankSigneringApproveByDate: any, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string } }>, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type SwitchingContractFragment = { __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } }, externalInsuranceCancellation?: { __typename?: 'ContractExternalInsuranceCancellation', id: string, status: ContractExternalInsuranceCancellationStatus, externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, bankSignering?: { __typename?: 'ContractBankSigneringCancellation', approveByDate: any, url?: string | null } | null } | null };

export type TrustlyInitMutationVariables = Exact<{
  successUrl: Scalars['String']['input'];
  failureUrl: Scalars['String']['input'];
}>;


export type TrustlyInitMutation = { __typename?: 'Mutation', registerDirectDebit2: { __typename?: 'DirectDebitResponse2', url: string, orderId: string } };

export type SendEventBatchMutationVariables = Exact<{
  inputList: Array<EventInput> | EventInput;
}>;


export type SendEventBatchMutation = { __typename?: 'Mutation', sendEventBatch: Array<string> };

export const PerilFragmentDoc = gql`
    fragment Peril on Peril {
  title
  description
  covered
  exceptions
  colorCode
}
    `;
export const InsuranceDocumentFragmentDoc = gql`
    fragment InsuranceDocument on InsuranceDocument {
  displayName
  type
  url
}
    `;
export const ProductVariantFragmentDoc = gql`
    fragment ProductVariant on ProductVariant {
  typeOfContract
  termsVersion
  displayName
  displayNameSubtype
  perils {
    ...Peril
  }
  insurableLimits {
    type
    label
    limit
    description
  }
  documents {
    ...InsuranceDocument
  }
}
    ${PerilFragmentDoc}
${InsuranceDocumentFragmentDoc}`;
export const ProductDataFullFragmentDoc = gql`
    fragment ProductDataFull on Product {
  id
  name
  displayNameFull
  displayNameShort
  tagline
  pageLink
  priceCalculatorPageLink
  pillowImage {
    id
    alt
    src
  }
  variants {
    ...ProductVariant
  }
}
    ${ProductVariantFragmentDoc}`;
export const ProductRecommendationFragmentDoc = gql`
    fragment ProductRecommendation on Product {
  id
  name
  displayNameFull
  displayNameShort
  tagline
  pageLink
  priceCalculatorPageLink
  pillowImage {
    id
    src
    alt
  }
  featuredImage {
    id
    src
    alt
  }
}
    `;
export const OfferRecommendationFragmentDoc = gql`
    fragment OfferRecommendation on ProductOffer {
  id
  startDate
  priceIntentData
  displayItems {
    key
    displayTitle
    displayValue
  }
  product {
    id
    name
    displayNameFull
  }
  variant {
    typeOfContract
    perils {
      ...Peril
    }
  }
  cost {
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
  }
}
    ${PerilFragmentDoc}`;
export const RecommendationFragmentDoc = gql`
    fragment Recommendation on ProductRecommendation {
  product {
    ...ProductRecommendation
  }
  offer {
    ...OfferRecommendation
  }
}
    ${ProductRecommendationFragmentDoc}
${OfferRecommendationFragmentDoc}`;
export const ProductOfferFragmentDoc = gql`
    fragment ProductOffer on ProductOffer {
  id
  product {
    id
    name
    pageLink
    priceCalculatorPageLink
    displayNameShort
    displayNameFull
    multiple
    pillowImage {
      id
      alt
      src
    }
  }
  variant {
    typeOfContract
    displayName
    displayNameSubtype
    perils {
      ...Peril
    }
    documents {
      type
      displayName
      url
    }
  }
  cost {
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
  }
  startDate
  cancellation {
    option
    requested
    externalInsurer {
      id
      displayName
    }
    bankSigneringApproveByDate
  }
  priceMatch {
    externalInsurer {
      id
      displayName
    }
    priceReduction {
      amount
      currencyCode
    }
    externalPrice {
      amount
      currencyCode
    }
  }
  priceIntentId
  priceIntentData
  deductible {
    displayName
    tagline
  }
  displayItems {
    key
    value
    displayTitle
    displayValue
  }
  exposure {
    displayNameShort
  }
}
    ${PerilFragmentDoc}`;
export const PriceIntentCarTrialExtensionFragmentDoc = gql`
    fragment PriceIntentCarTrialExtension on PriceIntent {
  id
  data
  suggestedData
  offers {
    ...ProductOffer
  }
  product {
    id
    name
    displayNameShort
    pageLink
    pillowImage {
      src
    }
  }
  defaultOffer {
    ...ProductOffer
  }
}
    ${ProductOfferFragmentDoc}`;
export const TrialContractFragmentDoc = gql`
    fragment TrialContract on TrialContract {
  id
  exposureDisplayName
  terminationDate
  activeFrom
  activeTo
  displayItems {
    displayTitle
    displayValue
  }
  premium {
    amount
    currencyCode
  }
  productVariant {
    displayName
    displayNameSubtype
    documents {
      displayName
      type
      url
    }
  }
}
    `;
export const MemberContractFragmentDoc = gql`
    fragment MemberContract on Contract {
  id
  currentAgreement {
    activeFrom
    activeTo
    certificateUrl
    displayItems {
      displayTitle
      displayValue
    }
    premium {
      amount
      currencyCode
    }
    productVariant {
      displayName
      typeOfContract
      termsVersion
      documents {
        ...InsuranceDocument
      }
      insurableLimits {
        label
        limit
      }
      perils {
        colorCode
        covered
        description
        exceptions
        title
      }
    }
  }
  exposureDisplayName
}
    ${InsuranceDocumentFragmentDoc}`;
export const MemberInsuranceCostFragmentDoc = gql`
    fragment MemberInsuranceCost on MemberInsuranceCost {
  freeUntil
  monthlyDiscount {
    amount
    currencyCode
  }
  monthlyGross {
    amount
    currencyCode
  }
  monthlyNet {
    currencyCode
    amount
  }
}
    `;
export const RetargetingPriceIntentFragmentDoc = gql`
    fragment RetargetingPriceIntent on PriceIntent {
  id
  data
  defaultOffer {
    id
    cost {
      gross {
        amount
      }
    }
  }
  product {
    name
  }
}
    `;
export const PriceIntentFragmentDoc = gql`
    fragment PriceIntent on PriceIntent {
  id
  data
  suggestedData
  offers {
    ...ProductOffer
  }
  externalInsurer {
    id
    displayName
    insurelyId
  }
  product {
    id
    name
    displayNameShort
    pageLink
    priceCalculatorPageLink
  }
  insurely {
    configName
    partner
  }
  notifications {
    message
  }
}
    ${ProductOfferFragmentDoc}`;
export const WidgetPriceIntentFragmentDoc = gql`
    fragment WidgetPriceIntent on PriceIntent {
  ...PriceIntent
  product {
    displayNameShort
    pillowImage {
      src
      alt
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export const MemberFragmentDoc = gql`
    fragment Member on Member {
  id
  email
  firstName
  lastName
  paymentInformation {
    status
  }
  partnerData {
    sas {
      eligible
      eurobonusNumber
    }
  }
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  name
  displayNameShort
  displayNameFull
  tagline
  pageLink
  priceCalculatorPageLink
  categoryPageLink
  pillowImage {
    id
    alt
    src
  }
}
    `;
export const ShopSessionCustomerFragmentDoc = gql`
    fragment ShopSessionCustomer on ShopSessionCustomer {
  missingFields
  ssn
}
    `;
export const RedeemedCampaignFragmentDoc = gql`
    fragment RedeemedCampaign on RedeemedCampaign {
  id
  code
  discount {
    type
    amount {
      currencyCode
      amount
    }
    percentage
    months
  }
}
    `;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  campaignsEnabled
  cost {
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
  }
  redeemedCampaign {
    ...RedeemedCampaign
  }
  entries {
    ...ProductOffer
  }
}
    ${RedeemedCampaignFragmentDoc}
${ProductOfferFragmentDoc}`;
export const ShopSessionFragmentDoc = gql`
    fragment ShopSession on ShopSession {
  id
  countryCode
  currencyCode
  customer {
    ...ShopSessionCustomer
  }
  cart {
    ...Cart
  }
  experiments {
    bundleDiscount
  }
}
    ${ShopSessionCustomerFragmentDoc}
${CartFragmentDoc}`;
export const ContractExternalInsuranceCancellationFragmentDoc = gql`
    fragment ContractExternalInsuranceCancellation on ContractExternalInsuranceCancellation {
  id
  status
  externalInsurer {
    id
    displayName
  }
  bankSignering {
    approveByDate
    url
  }
}
    `;
export const SwitchingContractFragmentDoc = gql`
    fragment SwitchingContract on Contract {
  id
  currentAgreement {
    productVariant {
      displayName
      displayNameSubtype
    }
  }
  externalInsuranceCancellation {
    ...ContractExternalInsuranceCancellation
  }
}
    ${ContractExternalInsuranceCancellationFragmentDoc}`;
export const ShopSessionOutcomeFragmentDoc = gql`
    fragment ShopSessionOutcome on ShopSessionOutcome {
  id
  createdContracts {
    ...SwitchingContract
  }
}
    ${SwitchingContractFragmentDoc}`;
export const ShopSessionSigningFragmentDoc = gql`
    fragment ShopSessionSigning on ShopSessionSigning {
  id
  status
  seBankidProperties {
    autoStartToken
    liveQrCodeData
    bankidAppOpened
  }
  completion {
    authorizationCode
  }
  userError {
    message
  }
}
    `;
export const SwitcherCaseCompleteDocument = gql`
    mutation SwitcherCaseComplete($id: UUID!, $currentExpiryDate: Date!) {
  switcherCaseComplete(id: $id, currentExpiryDate: $currentExpiryDate) {
    switcherCase {
      id
      isCompleted
    }
    userError {
      message
    }
  }
}
    `;
export type SwitcherCaseCompleteMutationFn = Apollo.MutationFunction<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>;

/**
 * __useSwitcherCaseCompleteMutation__
 *
 * To run a mutation, you first call `useSwitcherCaseCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitcherCaseCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switcherCaseCompleteMutation, { data, loading, error }] = useSwitcherCaseCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentExpiryDate: // value for 'currentExpiryDate'
 *   },
 * });
 */
export function useSwitcherCaseCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>(SwitcherCaseCompleteDocument, options);
      }
export type SwitcherCaseCompleteMutationHookResult = ReturnType<typeof useSwitcherCaseCompleteMutation>;
export type SwitcherCaseCompleteMutationResult = Apollo.MutationResult<SwitcherCaseCompleteMutation>;
export type SwitcherCaseCompleteMutationOptions = Apollo.BaseMutationOptions<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>;
export const SwitcherCaseDocument = gql`
    query SwitcherCase($id: UUID!) {
  switcherCase(id: $id) {
    id
    isCompleted
  }
}
    `;

/**
 * __useSwitcherCaseQuery__
 *
 * To run a query within a React component, call `useSwitcherCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitcherCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitcherCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSwitcherCaseQuery(baseOptions: Apollo.QueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables> & ({ variables: SwitcherCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
      }
export function useSwitcherCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
        }
export function useSwitcherCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
        }
export type SwitcherCaseQueryHookResult = ReturnType<typeof useSwitcherCaseQuery>;
export type SwitcherCaseLazyQueryHookResult = ReturnType<typeof useSwitcherCaseLazyQuery>;
export type SwitcherCaseSuspenseQueryHookResult = ReturnType<typeof useSwitcherCaseSuspenseQuery>;
export type SwitcherCaseQueryResult = Apollo.QueryResult<SwitcherCaseQuery, SwitcherCaseQueryVariables>;
export const ProductDataDocument = gql`
    query ProductData($productName: String!, $partnerName: String) {
  product(productName: $productName, partnerName: $partnerName) {
    ...ProductDataFull
  }
}
    ${ProductDataFullFragmentDoc}`;

/**
 * __useProductDataQuery__
 *
 * To run a query within a React component, call `useProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDataQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *      partnerName: // value for 'partnerName'
 *   },
 * });
 */
export function useProductDataQuery(baseOptions: Apollo.QueryHookOptions<ProductDataQuery, ProductDataQueryVariables> & ({ variables: ProductDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
      }
export function useProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
        }
export function useProductDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
        }
export type ProductDataQueryHookResult = ReturnType<typeof useProductDataQuery>;
export type ProductDataLazyQueryHookResult = ReturnType<typeof useProductDataLazyQuery>;
export type ProductDataSuspenseQueryHookResult = ReturnType<typeof useProductDataSuspenseQuery>;
export type ProductDataQueryResult = Apollo.QueryResult<ProductDataQuery, ProductDataQueryVariables>;
export const ProductRecommendationsDocument = gql`
    query ProductRecommendations($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    recommendations {
      ...Recommendation
    }
  }
}
    ${RecommendationFragmentDoc}`;

/**
 * __useProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRecommendationsQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useProductRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables> & ({ variables: ProductRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
      }
export function useProductRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
        }
export function useProductRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
        }
export type ProductRecommendationsQueryHookResult = ReturnType<typeof useProductRecommendationsQuery>;
export type ProductRecommendationsLazyQueryHookResult = ReturnType<typeof useProductRecommendationsLazyQuery>;
export type ProductRecommendationsSuspenseQueryHookResult = ReturnType<typeof useProductRecommendationsSuspenseQuery>;
export type ProductRecommendationsQueryResult = Apollo.QueryResult<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>;
export const CarDealershipRemoveAddDocument = gql`
    mutation CarDealershipRemoveAdd($shopSessionId: UUID!, $removeOfferIds: [UUID!]!, $addOfferIds: [UUID!]!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: $removeOfferIds}
  ) {
    shopSession {
      cart {
        entries {
          id
        }
      }
    }
    userError {
      message
    }
  }
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: $addOfferIds}
  ) {
    shopSession {
      cart {
        entries {
          id
        }
      }
    }
    userError {
      message
    }
  }
}
    `;
export type CarDealershipRemoveAddMutationFn = Apollo.MutationFunction<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>;

/**
 * __useCarDealershipRemoveAddMutation__
 *
 * To run a mutation, you first call `useCarDealershipRemoveAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarDealershipRemoveAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carDealershipRemoveAddMutation, { data, loading, error }] = useCarDealershipRemoveAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      removeOfferIds: // value for 'removeOfferIds'
 *      addOfferIds: // value for 'addOfferIds'
 *   },
 * });
 */
export function useCarDealershipRemoveAddMutation(baseOptions?: Apollo.MutationHookOptions<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>(CarDealershipRemoveAddDocument, options);
      }
export type CarDealershipRemoveAddMutationHookResult = ReturnType<typeof useCarDealershipRemoveAddMutation>;
export type CarDealershipRemoveAddMutationResult = Apollo.MutationResult<CarDealershipRemoveAddMutation>;
export type CarDealershipRemoveAddMutationOptions = Apollo.BaseMutationOptions<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>;
export const CarTrialExtensionDocument = gql`
    query CarTrialExtension($contractId: UUID!) {
  carTrial(contractId: $contractId) {
    id
    collectConsent
    consentGiven
    priceIntent {
      ...PriceIntentCarTrialExtension
    }
    shopSession {
      ...ShopSession
    }
    trialContract {
      ...TrialContract
    }
  }
}
    ${PriceIntentCarTrialExtensionFragmentDoc}
${ShopSessionFragmentDoc}
${TrialContractFragmentDoc}`;

/**
 * __useCarTrialExtensionQuery__
 *
 * To run a query within a React component, call `useCarTrialExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarTrialExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarTrialExtensionQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCarTrialExtensionQuery(baseOptions: Apollo.QueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables> & ({ variables: CarTrialExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
      }
export function useCarTrialExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
        }
export function useCarTrialExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
        }
export type CarTrialExtensionQueryHookResult = ReturnType<typeof useCarTrialExtensionQuery>;
export type CarTrialExtensionLazyQueryHookResult = ReturnType<typeof useCarTrialExtensionLazyQuery>;
export type CarTrialExtensionSuspenseQueryHookResult = ReturnType<typeof useCarTrialExtensionSuspenseQuery>;
export type CarTrialExtensionQueryResult = Apollo.QueryResult<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>;
export const PriceIntentDataUpdateCarDocument = gql`
    mutation PriceIntentDataUpdateCar($priceIntentId: UUID!, $data: PricingFormData!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentDataUpdateCarMutationFn = Apollo.MutationFunction<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>;

/**
 * __usePriceIntentDataUpdateCarMutation__
 *
 * To run a mutation, you first call `usePriceIntentDataUpdateCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentDataUpdateCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentDataUpdateCarMutation, { data, loading, error }] = usePriceIntentDataUpdateCarMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePriceIntentDataUpdateCarMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>(PriceIntentDataUpdateCarDocument, options);
      }
export type PriceIntentDataUpdateCarMutationHookResult = ReturnType<typeof usePriceIntentDataUpdateCarMutation>;
export type PriceIntentDataUpdateCarMutationResult = Apollo.MutationResult<PriceIntentDataUpdateCarMutation>;
export type PriceIntentDataUpdateCarMutationOptions = Apollo.BaseMutationOptions<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>;
export const MemberAreaMemberInfoDocument = gql`
    query MemberAreaMemberInfo {
  currentMember {
    activeContracts {
      ...MemberContract
    }
    firstName
    lastName
    email
    ssn
    paymentInformation {
      status
      connection {
        descriptor
        displayName
      }
    }
    insuranceCost {
      ...MemberInsuranceCost
    }
  }
}
    ${MemberContractFragmentDoc}
${MemberInsuranceCostFragmentDoc}`;

/**
 * __useMemberAreaMemberInfoQuery__
 *
 * To run a query within a React component, call `useMemberAreaMemberInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAreaMemberInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAreaMemberInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberAreaMemberInfoQuery(baseOptions?: Apollo.QueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
      }
export function useMemberAreaMemberInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
        }
export function useMemberAreaMemberInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
        }
export type MemberAreaMemberInfoQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoQuery>;
export type MemberAreaMemberInfoLazyQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoLazyQuery>;
export type MemberAreaMemberInfoSuspenseQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoSuspenseQuery>;
export type MemberAreaMemberInfoQueryResult = Apollo.QueryResult<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>;
export const TravelCertificateCreateDocument = gql`
    mutation TravelCertificateCreate($input: TravelCertificateCreateInput!) {
  travelCertificateCreate(input: $input) {
    id
    signedUrl
  }
}
    `;
export type TravelCertificateCreateMutationFn = Apollo.MutationFunction<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>;

/**
 * __useTravelCertificateCreateMutation__
 *
 * To run a mutation, you first call `useTravelCertificateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelCertificateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelCertificateCreateMutation, { data, loading, error }] = useTravelCertificateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelCertificateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>(TravelCertificateCreateDocument, options);
      }
export type TravelCertificateCreateMutationHookResult = ReturnType<typeof useTravelCertificateCreateMutation>;
export type TravelCertificateCreateMutationResult = Apollo.MutationResult<TravelCertificateCreateMutation>;
export type TravelCertificateCreateMutationOptions = Apollo.BaseMutationOptions<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>;
export const CartEntriesAddDocument = gql`
    mutation CartEntriesAdd($shopSessionId: UUID!, $offerIds: [UUID!]!) {
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: $offerIds}
  ) {
    shopSession {
      id
    }
    userError {
      message
    }
  }
}
    `;
export type CartEntriesAddMutationFn = Apollo.MutationFunction<CartEntriesAddMutation, CartEntriesAddMutationVariables>;

/**
 * __useCartEntriesAddMutation__
 *
 * To run a mutation, you first call `useCartEntriesAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntriesAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntriesAddMutation, { data, loading, error }] = useCartEntriesAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerIds: // value for 'offerIds'
 *   },
 * });
 */
export function useCartEntriesAddMutation(baseOptions?: Apollo.MutationHookOptions<CartEntriesAddMutation, CartEntriesAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntriesAddMutation, CartEntriesAddMutationVariables>(CartEntriesAddDocument, options);
      }
export type CartEntriesAddMutationHookResult = ReturnType<typeof useCartEntriesAddMutation>;
export type CartEntriesAddMutationResult = Apollo.MutationResult<CartEntriesAddMutation>;
export type CartEntriesAddMutationOptions = Apollo.BaseMutationOptions<CartEntriesAddMutation, CartEntriesAddMutationVariables>;
export const ShopSessionRetargetingDocument = gql`
    query ShopSessionRetargeting($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    cart {
      entries {
        id
      }
      campaignsEnabled
    }
    priceIntents(filters: {uniqueConfirmed: true}) {
      ...RetargetingPriceIntent
    }
  }
}
    ${RetargetingPriceIntentFragmentDoc}`;

/**
 * __useShopSessionRetargetingQuery__
 *
 * To run a query within a React component, call `useShopSessionRetargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionRetargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionRetargetingQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionRetargetingQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables> & ({ variables: ShopSessionRetargetingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
      }
export function useShopSessionRetargetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
        }
export function useShopSessionRetargetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
        }
export type ShopSessionRetargetingQueryHookResult = ReturnType<typeof useShopSessionRetargetingQuery>;
export type ShopSessionRetargetingLazyQueryHookResult = ReturnType<typeof useShopSessionRetargetingLazyQuery>;
export type ShopSessionRetargetingSuspenseQueryHookResult = ReturnType<typeof useShopSessionRetargetingSuspenseQuery>;
export type ShopSessionRetargetingQueryResult = Apollo.QueryResult<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>;
export const WidgetPriceIntentDocument = gql`
    query WidgetPriceIntent($priceIntentId: UUID!) {
  priceIntent(id: $priceIntentId) {
    ...WidgetPriceIntent
  }
}
    ${WidgetPriceIntentFragmentDoc}`;

/**
 * __useWidgetPriceIntentQuery__
 *
 * To run a query within a React component, call `useWidgetPriceIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetPriceIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetPriceIntentQuery({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function useWidgetPriceIntentQuery(baseOptions: Apollo.QueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables> & ({ variables: WidgetPriceIntentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
      }
export function useWidgetPriceIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
        }
export function useWidgetPriceIntentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
        }
export type WidgetPriceIntentQueryHookResult = ReturnType<typeof useWidgetPriceIntentQuery>;
export type WidgetPriceIntentLazyQueryHookResult = ReturnType<typeof useWidgetPriceIntentLazyQuery>;
export type WidgetPriceIntentSuspenseQueryHookResult = ReturnType<typeof useWidgetPriceIntentSuspenseQuery>;
export type WidgetPriceIntentQueryResult = Apollo.QueryResult<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>;
export const CartEntryAddDocument = gql`
    mutation CartEntryAdd($shopSessionId: UUID!, $offerId: UUID!) {
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: [$offerId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type CartEntryAddMutationFn = Apollo.MutationFunction<CartEntryAddMutation, CartEntryAddMutationVariables>;

/**
 * __useCartEntryAddMutation__
 *
 * To run a mutation, you first call `useCartEntryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryAddMutation, { data, loading, error }] = useCartEntryAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryAddMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryAddMutation, CartEntryAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryAddMutation, CartEntryAddMutationVariables>(CartEntryAddDocument, options);
      }
export type CartEntryAddMutationHookResult = ReturnType<typeof useCartEntryAddMutation>;
export type CartEntryAddMutationResult = Apollo.MutationResult<CartEntryAddMutation>;
export type CartEntryAddMutationOptions = Apollo.BaseMutationOptions<CartEntryAddMutation, CartEntryAddMutationVariables>;
export const CartEntryRemoveDocument = gql`
    mutation CartEntryRemove($shopSessionId: UUID!, $offerId: UUID!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: [$offerId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type CartEntryRemoveMutationFn = Apollo.MutationFunction<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;

/**
 * __useCartEntryRemoveMutation__
 *
 * To run a mutation, you first call `useCartEntryRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryRemoveMutation, { data, loading, error }] = useCartEntryRemoveMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>(CartEntryRemoveDocument, options);
      }
export type CartEntryRemoveMutationHookResult = ReturnType<typeof useCartEntryRemoveMutation>;
export type CartEntryRemoveMutationResult = Apollo.MutationResult<CartEntryRemoveMutation>;
export type CartEntryRemoveMutationOptions = Apollo.BaseMutationOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;
export const CartEntryReplaceDocument = gql`
    mutation CartEntryReplace($shopSessionId: UUID!, $removeOfferId: UUID!, $addOfferId: UUID!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: [$removeOfferId]}
  ) {
    shopSession {
      id
    }
    userError {
      message
    }
  }
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: [$addOfferId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type CartEntryReplaceMutationFn = Apollo.MutationFunction<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>;

/**
 * __useCartEntryReplaceMutation__
 *
 * To run a mutation, you first call `useCartEntryReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryReplaceMutation, { data, loading, error }] = useCartEntryReplaceMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      removeOfferId: // value for 'removeOfferId'
 *      addOfferId: // value for 'addOfferId'
 *   },
 * });
 */
export function useCartEntryReplaceMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>(CartEntryReplaceDocument, options);
      }
export type CartEntryReplaceMutationHookResult = ReturnType<typeof useCartEntryReplaceMutation>;
export type CartEntryReplaceMutationResult = Apollo.MutationResult<CartEntryReplaceMutation>;
export type CartEntryReplaceMutationOptions = Apollo.BaseMutationOptions<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>;
export const RedeemCampaignDocument = gql`
    mutation RedeemCampaign($shopSessionId: UUID!, $code: String!) {
  shopSessionCartCampaignRedeem(
    input: {shopSessionId: $shopSessionId, code: $code}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type RedeemCampaignMutationFn = Apollo.MutationFunction<RedeemCampaignMutation, RedeemCampaignMutationVariables>;

/**
 * __useRedeemCampaignMutation__
 *
 * To run a mutation, you first call `useRedeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemCampaignMutation, { data, loading, error }] = useRedeemCampaignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemCampaignMutation, RedeemCampaignMutationVariables>(RedeemCampaignDocument, options);
      }
export type RedeemCampaignMutationHookResult = ReturnType<typeof useRedeemCampaignMutation>;
export type RedeemCampaignMutationResult = Apollo.MutationResult<RedeemCampaignMutation>;
export type RedeemCampaignMutationOptions = Apollo.BaseMutationOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>;
export const UnredeemCampaignDocument = gql`
    mutation UnredeemCampaign($shopSessionId: UUID!, $campaignId: String!) {
  shopSessionCartCampaignUnredeem(
    input: {shopSessionId: $shopSessionId, campaignId: $campaignId}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type UnredeemCampaignMutationFn = Apollo.MutationFunction<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;

/**
 * __useUnredeemCampaignMutation__
 *
 * To run a mutation, you first call `useUnredeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnredeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unredeemCampaignMutation, { data, loading, error }] = useUnredeemCampaignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUnredeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>(UnredeemCampaignDocument, options);
      }
export type UnredeemCampaignMutationHookResult = ReturnType<typeof useUnredeemCampaignMutation>;
export type UnredeemCampaignMutationResult = Apollo.MutationResult<UnredeemCampaignMutation>;
export type UnredeemCampaignMutationOptions = Apollo.BaseMutationOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;
export const ContractDocument = gql`
    query Contract($id: UUID!) {
  contract(id: $id) {
    ...SwitchingContract
  }
}
    ${SwitchingContractFragmentDoc}`;

/**
 * __useContractQuery__
 *
 * To run a query within a React component, call `useContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractQuery(baseOptions: Apollo.QueryHookOptions<ContractQuery, ContractQueryVariables> & ({ variables: ContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
      }
export function useContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export function useContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export type ContractQueryHookResult = ReturnType<typeof useContractQuery>;
export type ContractLazyQueryHookResult = ReturnType<typeof useContractLazyQuery>;
export type ContractSuspenseQueryHookResult = ReturnType<typeof useContractSuspenseQuery>;
export type ContractQueryResult = Apollo.QueryResult<ContractQuery, ContractQueryVariables>;
export const BankSigneringInitDocument = gql`
    mutation BankSigneringInit($contractId: UUID!) {
  contractBankSigneringCancellationInitiate(contractId: $contractId) {
    id
    externalInsuranceCancellation {
      ...ContractExternalInsuranceCancellation
    }
  }
}
    ${ContractExternalInsuranceCancellationFragmentDoc}`;
export type BankSigneringInitMutationFn = Apollo.MutationFunction<BankSigneringInitMutation, BankSigneringInitMutationVariables>;

/**
 * __useBankSigneringInitMutation__
 *
 * To run a mutation, you first call `useBankSigneringInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankSigneringInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankSigneringInitMutation, { data, loading, error }] = useBankSigneringInitMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useBankSigneringInitMutation(baseOptions?: Apollo.MutationHookOptions<BankSigneringInitMutation, BankSigneringInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BankSigneringInitMutation, BankSigneringInitMutationVariables>(BankSigneringInitDocument, options);
      }
export type BankSigneringInitMutationHookResult = ReturnType<typeof useBankSigneringInitMutation>;
export type BankSigneringInitMutationResult = Apollo.MutationResult<BankSigneringInitMutation>;
export type BankSigneringInitMutationOptions = Apollo.BaseMutationOptions<BankSigneringInitMutation, BankSigneringInitMutationVariables>;
export const CurrentMemberDocument = gql`
    query CurrentMember {
  currentMember {
    ...Member
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useCurrentMemberQuery__
 *
 * To run a query within a React component, call `useCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMemberQuery(baseOptions?: Apollo.QueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
      }
export function useCurrentMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
        }
export function useCurrentMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
        }
export type CurrentMemberQueryHookResult = ReturnType<typeof useCurrentMemberQuery>;
export type CurrentMemberLazyQueryHookResult = ReturnType<typeof useCurrentMemberLazyQuery>;
export type CurrentMemberSuspenseQueryHookResult = ReturnType<typeof useCurrentMemberSuspenseQuery>;
export type CurrentMemberQueryResult = Apollo.QueryResult<CurrentMemberQuery, CurrentMemberQueryVariables>;
export const ExternalInsurerUpdateDocument = gql`
    mutation ExternalInsurerUpdate($priceIntentId: UUID!, $externalInsurerId: ID) {
  priceIntentExternalInsurerUpdate(
    priceIntentId: $priceIntentId
    externalInsurerId: $externalInsurerId
  ) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export type ExternalInsurerUpdateMutationFn = Apollo.MutationFunction<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;

/**
 * __useExternalInsurerUpdateMutation__
 *
 * To run a mutation, you first call `useExternalInsurerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalInsurerUpdateMutation, { data, loading, error }] = useExternalInsurerUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      externalInsurerId: // value for 'externalInsurerId'
 *   },
 * });
 */
export function useExternalInsurerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>(ExternalInsurerUpdateDocument, options);
      }
export type ExternalInsurerUpdateMutationHookResult = ReturnType<typeof useExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationResult = Apollo.MutationResult<ExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationOptions = Apollo.BaseMutationOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;
export const ExternalInsurersDocument = gql`
    query ExternalInsurers($productName: String!) {
  product(productName: $productName) {
    externalInsurers {
      id
      displayName
    }
  }
}
    `;

/**
 * __useExternalInsurersQuery__
 *
 * To run a query within a React component, call `useExternalInsurersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalInsurersQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useExternalInsurersQuery(baseOptions: Apollo.QueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables> & ({ variables: ExternalInsurersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
      }
export function useExternalInsurersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
        }
export function useExternalInsurersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
        }
export type ExternalInsurersQueryHookResult = ReturnType<typeof useExternalInsurersQuery>;
export type ExternalInsurersLazyQueryHookResult = ReturnType<typeof useExternalInsurersLazyQuery>;
export type ExternalInsurersSuspenseQueryHookResult = ReturnType<typeof useExternalInsurersSuspenseQuery>;
export type ExternalInsurersQueryResult = Apollo.QueryResult<ExternalInsurersQuery, ExternalInsurersQueryVariables>;
export const InsurelyDataCollectionCreateDocument = gql`
    mutation InsurelyDataCollectionCreate($collectionId: String!, $partner: String!) {
  insurelyInitiateIframeDataCollection(
    input: {collectionId: $collectionId, partner: $partner}
  ) {
    dataCollectionId
  }
}
    `;
export type InsurelyDataCollectionCreateMutationFn = Apollo.MutationFunction<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;

/**
 * __useInsurelyDataCollectionCreateMutation__
 *
 * To run a mutation, you first call `useInsurelyDataCollectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsurelyDataCollectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insurelyDataCollectionCreateMutation, { data, loading, error }] = useInsurelyDataCollectionCreateMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useInsurelyDataCollectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>(InsurelyDataCollectionCreateDocument, options);
      }
export type InsurelyDataCollectionCreateMutationHookResult = ReturnType<typeof useInsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationResult = Apollo.MutationResult<InsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationOptions = Apollo.BaseMutationOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;
export const PriceIntentDocument = gql`
    query PriceIntent($priceIntentId: UUID!) {
  priceIntent(id: $priceIntentId) {
    ...PriceIntent
  }
}
    ${PriceIntentFragmentDoc}`;

/**
 * __usePriceIntentQuery__
 *
 * To run a query within a React component, call `usePriceIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentQuery({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables> & ({ variables: PriceIntentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
      }
export function usePriceIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
        }
export function usePriceIntentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
        }
export type PriceIntentQueryHookResult = ReturnType<typeof usePriceIntentQuery>;
export type PriceIntentLazyQueryHookResult = ReturnType<typeof usePriceIntentLazyQuery>;
export type PriceIntentSuspenseQueryHookResult = ReturnType<typeof usePriceIntentSuspenseQuery>;
export type PriceIntentQueryResult = Apollo.QueryResult<PriceIntentQuery, PriceIntentQueryVariables>;
export const PriceIntentAvailableBreedsDocument = gql`
    query PriceIntentAvailableBreeds($animal: PriceIntentAnimal!) {
  priceIntentAvailableBreeds(animal: $animal) {
    id
    displayName
    isMixedBreed
  }
}
    `;

/**
 * __usePriceIntentAvailableBreedsQuery__
 *
 * To run a query within a React component, call `usePriceIntentAvailableBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentAvailableBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentAvailableBreedsQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *   },
 * });
 */
export function usePriceIntentAvailableBreedsQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables> & ({ variables: PriceIntentAvailableBreedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
      }
export function usePriceIntentAvailableBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
        }
export function usePriceIntentAvailableBreedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
        }
export type PriceIntentAvailableBreedsQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsQuery>;
export type PriceIntentAvailableBreedsLazyQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsLazyQuery>;
export type PriceIntentAvailableBreedsSuspenseQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsSuspenseQuery>;
export type PriceIntentAvailableBreedsQueryResult = Apollo.QueryResult<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>;
export const CancellationRequestedUpdateDocument = gql`
    mutation CancellationRequestedUpdate($productOfferIds: [UUID!]!, $requested: Boolean!) {
  productOffersCancellationRequestedUpdate(
    productOfferIds: $productOfferIds
    requested: $requested
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      message
    }
  }
}
    ${ProductOfferFragmentDoc}`;
export type CancellationRequestedUpdateMutationFn = Apollo.MutationFunction<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;

/**
 * __useCancellationRequestedUpdateMutation__
 *
 * To run a mutation, you first call `useCancellationRequestedUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancellationRequestedUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancellationRequestedUpdateMutation, { data, loading, error }] = useCancellationRequestedUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      requested: // value for 'requested'
 *   },
 * });
 */
export function useCancellationRequestedUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>(CancellationRequestedUpdateDocument, options);
      }
export type CancellationRequestedUpdateMutationHookResult = ReturnType<typeof useCancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationResult = Apollo.MutationResult<CancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationOptions = Apollo.BaseMutationOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;
export const PriceIntentConfirmDocument = gql`
    mutation PriceIntentConfirm($priceIntentId: UUID!) {
  priceIntentConfirm(priceIntentId: $priceIntentId) {
    priceIntent {
      ...PriceIntent
      defaultOffer {
        id
      }
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentConfirmMutationFn = Apollo.MutationFunction<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;

/**
 * __usePriceIntentConfirmMutation__
 *
 * To run a mutation, you first call `usePriceIntentConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentConfirmMutation, { data, loading, error }] = usePriceIntentConfirmMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>(PriceIntentConfirmDocument, options);
      }
export type PriceIntentConfirmMutationHookResult = ReturnType<typeof usePriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationResult = Apollo.MutationResult<PriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationOptions = Apollo.BaseMutationOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;
export const PriceIntentCreateDocument = gql`
    mutation PriceIntentCreate($shopSessionId: UUID!, $productName: String!) {
  priceIntentCreate(
    input: {shopSessionId: $shopSessionId, productName: $productName}
  ) {
    ...PriceIntent
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentCreateMutationFn = Apollo.MutationFunction<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;

/**
 * __usePriceIntentCreateMutation__
 *
 * To run a mutation, you first call `usePriceIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentCreateMutation, { data, loading, error }] = usePriceIntentCreateMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function usePriceIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>(PriceIntentCreateDocument, options);
      }
export type PriceIntentCreateMutationHookResult = ReturnType<typeof usePriceIntentCreateMutation>;
export type PriceIntentCreateMutationResult = Apollo.MutationResult<PriceIntentCreateMutation>;
export type PriceIntentCreateMutationOptions = Apollo.BaseMutationOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;
export const PriceIntentDataUpdateDocument = gql`
    mutation PriceIntentDataUpdate($priceIntentId: UUID!, $data: PricingFormData!, $customer: ShopSessionCustomerUpdateInput!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      message
    }
  }
  shopSessionCustomerUpdate(input: $customer) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}
${ShopSessionFragmentDoc}`;
export type PriceIntentDataUpdateMutationFn = Apollo.MutationFunction<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;

/**
 * __usePriceIntentDataUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentDataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentDataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentDataUpdateMutation, { data, loading, error }] = usePriceIntentDataUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function usePriceIntentDataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>(PriceIntentDataUpdateDocument, options);
      }
export type PriceIntentDataUpdateMutationHookResult = ReturnType<typeof usePriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationResult = Apollo.MutationResult<PriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;
export const PriceIntentInsurelyUpdateDocument = gql`
    mutation PriceIntentInsurelyUpdate($priceIntentId: UUID!, $dataCollectionId: String!) {
  priceIntentInsurelyUpdate(
    priceIntentId: $priceIntentId
    dataCollectionId: $dataCollectionId
  ) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentInsurelyUpdateMutationFn = Apollo.MutationFunction<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;

/**
 * __usePriceIntentInsurelyUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentInsurelyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentInsurelyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentInsurelyUpdateMutation, { data, loading, error }] = usePriceIntentInsurelyUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      dataCollectionId: // value for 'dataCollectionId'
 *   },
 * });
 */
export function usePriceIntentInsurelyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>(PriceIntentInsurelyUpdateDocument, options);
      }
export type PriceIntentInsurelyUpdateMutationHookResult = ReturnType<typeof usePriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationResult = Apollo.MutationResult<PriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;
export const PriceIntentUpdateAndConfirmDocument = gql`
    mutation PriceIntentUpdateAndConfirm($priceIntentId: UUID!, $data: PricingFormData!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      id
      data
    }
    userError {
      message
    }
  }
  priceIntentConfirm(priceIntentId: $priceIntentId) {
    priceIntent {
      ...PriceIntent
      defaultOffer {
        id
      }
    }
    userError {
      message
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentUpdateAndConfirmMutationFn = Apollo.MutationFunction<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>;

/**
 * __usePriceIntentUpdateAndConfirmMutation__
 *
 * To run a mutation, you first call `usePriceIntentUpdateAndConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentUpdateAndConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentUpdateAndConfirmMutation, { data, loading, error }] = usePriceIntentUpdateAndConfirmMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePriceIntentUpdateAndConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>(PriceIntentUpdateAndConfirmDocument, options);
      }
export type PriceIntentUpdateAndConfirmMutationHookResult = ReturnType<typeof usePriceIntentUpdateAndConfirmMutation>;
export type PriceIntentUpdateAndConfirmMutationResult = Apollo.MutationResult<PriceIntentUpdateAndConfirmMutation>;
export type PriceIntentUpdateAndConfirmMutationOptions = Apollo.BaseMutationOptions<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>;
export const PriceIntentsDocument = gql`
    query PriceIntents($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    cart {
      entries {
        id
      }
    }
    priceIntents {
      id
      offers {
        ...ProductOffer
      }
    }
  }
}
    ${ProductOfferFragmentDoc}`;

/**
 * __usePriceIntentsQuery__
 *
 * To run a query within a React component, call `usePriceIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentsQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function usePriceIntentsQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentsQuery, PriceIntentsQueryVariables> & ({ variables: PriceIntentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentsQuery, PriceIntentsQueryVariables>(PriceIntentsDocument, options);
      }
export function usePriceIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentsQuery, PriceIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentsQuery, PriceIntentsQueryVariables>(PriceIntentsDocument, options);
        }
export function usePriceIntentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceIntentsQuery, PriceIntentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceIntentsQuery, PriceIntentsQueryVariables>(PriceIntentsDocument, options);
        }
export type PriceIntentsQueryHookResult = ReturnType<typeof usePriceIntentsQuery>;
export type PriceIntentsLazyQueryHookResult = ReturnType<typeof usePriceIntentsLazyQuery>;
export type PriceIntentsSuspenseQueryHookResult = ReturnType<typeof usePriceIntentsSuspenseQuery>;
export type PriceIntentsQueryResult = Apollo.QueryResult<PriceIntentsQuery, PriceIntentsQueryVariables>;
export const ProductMetadataDocument = gql`
    query ProductMetadata {
  availableProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductMetadataQuery__
 *
 * To run a query within a React component, call `useProductMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductMetadataQuery(baseOptions?: Apollo.QueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
      }
export function useProductMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
        }
export function useProductMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
        }
export type ProductMetadataQueryHookResult = ReturnType<typeof useProductMetadataQuery>;
export type ProductMetadataLazyQueryHookResult = ReturnType<typeof useProductMetadataLazyQuery>;
export type ProductMetadataSuspenseQueryHookResult = ReturnType<typeof useProductMetadataSuspenseQuery>;
export type ProductMetadataQueryResult = Apollo.QueryResult<ProductMetadataQuery, ProductMetadataQueryVariables>;
export const SasEurobonusNumberUpdateDocument = gql`
    mutation SasEurobonusNumberUpdate($value: String!) {
  memberUpdateEurobonusNumber(input: {eurobonusNumber: $value}) {
    member {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`;
export type SasEurobonusNumberUpdateMutationFn = Apollo.MutationFunction<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>;

/**
 * __useSasEurobonusNumberUpdateMutation__
 *
 * To run a mutation, you first call `useSasEurobonusNumberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSasEurobonusNumberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sasEurobonusNumberUpdateMutation, { data, loading, error }] = useSasEurobonusNumberUpdateMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSasEurobonusNumberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>(SasEurobonusNumberUpdateDocument, options);
      }
export type SasEurobonusNumberUpdateMutationHookResult = ReturnType<typeof useSasEurobonusNumberUpdateMutation>;
export type SasEurobonusNumberUpdateMutationResult = Apollo.MutationResult<SasEurobonusNumberUpdateMutation>;
export type SasEurobonusNumberUpdateMutationOptions = Apollo.BaseMutationOptions<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>;
export const ShopSessionDocument = gql`
    query ShopSession($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;

/**
 * __useShopSessionQuery__
 *
 * To run a query within a React component, call `useShopSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables> & ({ variables: ShopSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
      }
export function useShopSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
        }
export function useShopSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
        }
export type ShopSessionQueryHookResult = ReturnType<typeof useShopSessionQuery>;
export type ShopSessionLazyQueryHookResult = ReturnType<typeof useShopSessionLazyQuery>;
export type ShopSessionSuspenseQueryHookResult = ReturnType<typeof useShopSessionSuspenseQuery>;
export type ShopSessionQueryResult = Apollo.QueryResult<ShopSessionQuery, ShopSessionQueryVariables>;
export const ShopSessionCreateDocument = gql`
    mutation ShopSessionCreate($countryCode: CountryCode!, $attributedTo: String, $initiatedFrom: String) {
  shopSessionCreate(
    input: {countryCode: $countryCode, attributedTo: $attributedTo, initiatedFrom: $initiatedFrom}
  ) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionCreateMutationFn = Apollo.MutationFunction<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;

/**
 * __useShopSessionCreateMutation__
 *
 * To run a mutation, you first call `useShopSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCreateMutation, { data, loading, error }] = useShopSessionCreateMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      attributedTo: // value for 'attributedTo'
 *      initiatedFrom: // value for 'initiatedFrom'
 *   },
 * });
 */
export function useShopSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>(ShopSessionCreateDocument, options);
      }
export type ShopSessionCreateMutationHookResult = ReturnType<typeof useShopSessionCreateMutation>;
export type ShopSessionCreateMutationResult = Apollo.MutationResult<ShopSessionCreateMutation>;
export type ShopSessionCreateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;
export const ShopSessionCustomerUpdateDocument = gql`
    mutation ShopSessionCustomerUpdate($input: ShopSessionCustomerUpdateInput!) {
  shopSessionCustomerUpdate(input: $input) {
    shopSession {
      ...ShopSession
    }
    userError {
      message
    }
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionCustomerUpdateMutationFn = Apollo.MutationFunction<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;

/**
 * __useShopSessionCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useShopSessionCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCustomerUpdateMutation, { data, loading, error }] = useShopSessionCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShopSessionCustomerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>(ShopSessionCustomerUpdateDocument, options);
      }
export type ShopSessionCustomerUpdateMutationHookResult = ReturnType<typeof useShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationResult = Apollo.MutationResult<ShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;
export const ShopSessionOutcomeDocument = gql`
    query ShopSessionOutcome($shopSessionOutcomeId: UUID!) {
  shopSessionOutcome(id: $shopSessionOutcomeId) {
    ...ShopSessionOutcome
  }
}
    ${ShopSessionOutcomeFragmentDoc}`;

/**
 * __useShopSessionOutcomeQuery__
 *
 * To run a query within a React component, call `useShopSessionOutcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionOutcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionOutcomeQuery({
 *   variables: {
 *      shopSessionOutcomeId: // value for 'shopSessionOutcomeId'
 *   },
 * });
 */
export function useShopSessionOutcomeQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables> & ({ variables: ShopSessionOutcomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
      }
export function useShopSessionOutcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
        }
export function useShopSessionOutcomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
        }
export type ShopSessionOutcomeQueryHookResult = ReturnType<typeof useShopSessionOutcomeQuery>;
export type ShopSessionOutcomeLazyQueryHookResult = ReturnType<typeof useShopSessionOutcomeLazyQuery>;
export type ShopSessionOutcomeSuspenseQueryHookResult = ReturnType<typeof useShopSessionOutcomeSuspenseQuery>;
export type ShopSessionOutcomeQueryResult = Apollo.QueryResult<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>;
export const ShopSessionOutcomeIdDocument = gql`
    query ShopSessionOutcomeId($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    outcome {
      id
    }
  }
}
    `;

/**
 * __useShopSessionOutcomeIdQuery__
 *
 * To run a query within a React component, call `useShopSessionOutcomeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionOutcomeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionOutcomeIdQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionOutcomeIdQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables> & ({ variables: ShopSessionOutcomeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
      }
export function useShopSessionOutcomeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
        }
export function useShopSessionOutcomeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
        }
export type ShopSessionOutcomeIdQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdQuery>;
export type ShopSessionOutcomeIdLazyQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdLazyQuery>;
export type ShopSessionOutcomeIdSuspenseQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdSuspenseQuery>;
export type ShopSessionOutcomeIdQueryResult = Apollo.QueryResult<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>;
export const ShopSessionSigningDocument = gql`
    query ShopSessionSigning($shopSessionSigningId: UUID!) {
  shopSessionSigning(id: $shopSessionSigningId) {
    ...ShopSessionSigning
  }
}
    ${ShopSessionSigningFragmentDoc}`;

/**
 * __useShopSessionSigningQuery__
 *
 * To run a query within a React component, call `useShopSessionSigningQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionSigningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionSigningQuery({
 *   variables: {
 *      shopSessionSigningId: // value for 'shopSessionSigningId'
 *   },
 * });
 */
export function useShopSessionSigningQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables> & ({ variables: ShopSessionSigningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
      }
export function useShopSessionSigningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
        }
export function useShopSessionSigningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
        }
export type ShopSessionSigningQueryHookResult = ReturnType<typeof useShopSessionSigningQuery>;
export type ShopSessionSigningLazyQueryHookResult = ReturnType<typeof useShopSessionSigningLazyQuery>;
export type ShopSessionSigningSuspenseQueryHookResult = ReturnType<typeof useShopSessionSigningSuspenseQuery>;
export type ShopSessionSigningQueryResult = Apollo.QueryResult<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>;
export const ShopSessionStartSignDocument = gql`
    mutation ShopSessionStartSign($shopSessionId: UUID!) {
  shopSessionStartSign(shopSessionId: $shopSessionId) {
    signing {
      ...ShopSessionSigning
    }
    userError {
      message
    }
  }
}
    ${ShopSessionSigningFragmentDoc}`;
export type ShopSessionStartSignMutationFn = Apollo.MutationFunction<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;

/**
 * __useShopSessionStartSignMutation__
 *
 * To run a mutation, you first call `useShopSessionStartSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionStartSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionStartSignMutation, { data, loading, error }] = useShopSessionStartSignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionStartSignMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>(ShopSessionStartSignDocument, options);
      }
export type ShopSessionStartSignMutationHookResult = ReturnType<typeof useShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationResult = Apollo.MutationResult<ShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationOptions = Apollo.BaseMutationOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;
export const StartDateUpdateDocument = gql`
    mutation StartDateUpdate($productOfferIds: [UUID!]!, $startDate: Date!) {
  productOffersStartDateUpdate(
    productOfferIds: $productOfferIds
    startDate: $startDate
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      message
    }
  }
}
    ${ProductOfferFragmentDoc}`;
export type StartDateUpdateMutationFn = Apollo.MutationFunction<StartDateUpdateMutation, StartDateUpdateMutationVariables>;

/**
 * __useStartDateUpdateMutation__
 *
 * To run a mutation, you first call `useStartDateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDateUpdateMutation, { data, loading, error }] = useStartDateUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useStartDateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDateUpdateMutation, StartDateUpdateMutationVariables>(StartDateUpdateDocument, options);
      }
export type StartDateUpdateMutationHookResult = ReturnType<typeof useStartDateUpdateMutation>;
export type StartDateUpdateMutationResult = Apollo.MutationResult<StartDateUpdateMutation>;
export type StartDateUpdateMutationOptions = Apollo.BaseMutationOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>;
export const TrustlyInitDocument = gql`
    mutation TrustlyInit($successUrl: String!, $failureUrl: String!) {
  registerDirectDebit2(
    clientContext: {successUrl: $successUrl, failureUrl: $failureUrl}
  ) {
    url
    orderId
  }
}
    `;
export type TrustlyInitMutationFn = Apollo.MutationFunction<TrustlyInitMutation, TrustlyInitMutationVariables>;

/**
 * __useTrustlyInitMutation__
 *
 * To run a mutation, you first call `useTrustlyInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrustlyInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trustlyInitMutation, { data, loading, error }] = useTrustlyInitMutation({
 *   variables: {
 *      successUrl: // value for 'successUrl'
 *      failureUrl: // value for 'failureUrl'
 *   },
 * });
 */
export function useTrustlyInitMutation(baseOptions?: Apollo.MutationHookOptions<TrustlyInitMutation, TrustlyInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrustlyInitMutation, TrustlyInitMutationVariables>(TrustlyInitDocument, options);
      }
export type TrustlyInitMutationHookResult = ReturnType<typeof useTrustlyInitMutation>;
export type TrustlyInitMutationResult = Apollo.MutationResult<TrustlyInitMutation>;
export type TrustlyInitMutationOptions = Apollo.BaseMutationOptions<TrustlyInitMutation, TrustlyInitMutationVariables>;
export const SendEventBatchDocument = gql`
    mutation SendEventBatch($inputList: [EventInput!]!) {
  sendEventBatch(inputList: $inputList)
}
    `;
export type SendEventBatchMutationFn = Apollo.MutationFunction<SendEventBatchMutation, SendEventBatchMutationVariables>;

/**
 * __useSendEventBatchMutation__
 *
 * To run a mutation, you first call `useSendEventBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventBatchMutation, { data, loading, error }] = useSendEventBatchMutation({
 *   variables: {
 *      inputList: // value for 'inputList'
 *   },
 * });
 */
export function useSendEventBatchMutation(baseOptions?: Apollo.MutationHookOptions<SendEventBatchMutation, SendEventBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventBatchMutation, SendEventBatchMutationVariables>(SendEventBatchDocument, options);
      }
export type SendEventBatchMutationHookResult = ReturnType<typeof useSendEventBatchMutation>;
export type SendEventBatchMutationResult = Apollo.MutationResult<SendEventBatchMutation>;
export type SendEventBatchMutationOptions = Apollo.BaseMutationOptions<SendEventBatchMutation, SendEventBatchMutationVariables>;